import axios from "axios";
import SideNavbar from "../../../components/common/SideNavbar";
import TopNavbar from "../../../components/common/TopNavbar";
import { useEffect, useState, useRef } from "react";
import { Button, Spinner, Modal } from "react-bootstrap";
import { toast, ToastContainer } from "react-toastify";
import DataTable from "react-data-table-component";
import { shipmentTableCustomStyles, shipmentUploadsTableCustomStyles, hazardousDataTableCustomStyles, userTableCustomStyles, vesselWiseBookingCustomStyles } from "../../../utils/TableCustomStyles";
import { parseISO, format } from "date-fns";
import PlannedExportCro from "./PlannedExportCro";
import PlannedExportBl from "./PlannedExportBl";
import PlannedExportContainer from "./PlannedExportContainer";
import PlannedExportExportBilling from "./PlannedExportExportBilling";
import PlannedExportActivities from "./PlannedExportActivities";
import PlannedExportNotifications from "./PlannedExportNotifications";
import PlannedExportExpenses from "./PlannedExportExpenses";
import PlannedExportChat from "./PlannedExportChat";
import PlannedExportUploads from "./PlannedExportUploads";
import PlannedExportDocuments from "./PlannedExportDocuments";
import PlannedExportTasks from "./PlannedExportTasks";
import Select from "react-select";
import { useSelector } from "react-redux";
import { vesselScheduleTableCustomStyles } from "../../../utils/TableCustomStyles";
import { smallFormSelectCustomStyles } from "../../../utils/SelectCustomStyles";


function PlannedExport() {
  const currentSelectedPort = useSelector(
    (state) => state.location.currentSelectedPort
  );

  useEffect(() => {
    console.log("Updated Port:", currentSelectedPort);
    getShipment(currentPage, 10, exportOptionStatus)
  }, [currentSelectedPort]);

  const filterform = useRef(null);
  const addfreightform = useRef(null);
  const addrouteform = useRef(null);
  const addshipmentnotesform = useRef(null);
  const [menuDrawerShow, setMenuDrawerShow] = useState(true);
  const [data, setData] = useState([]);
  const [vesselShipmentData, setVesselShipmentData] = useState([]);
  const [salesUser, setSalesUser] = useState([]);
  const [dataPending, setDataPending] = useState(true);
  const [currentUserRolePermissionData, setCurrentUserRolePermissionData] = useState([]);
  const [dataFromTopNavBar, setDataFromTopNavBar] = useState("");
  const user_role = sessionStorage['userrole']
  const [showFilterForm, setShowFilterForm] = useState(false);
  const user_id = sessionStorage['id']
  const [loggedInUser, setLoggedInUser] = useState(null);
  const [totalData, setTotalData] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [exportOptionStatus, setExportOptionStatus] = useState("APPROVED");
  const [showDescriptionView, setShowDescriptionView] = useState(true);
  const [showGridView, setShowGridView] = useState(false);
  const [showVesselView, setShowVesselView] = useState(false);
  const [showSplitBookingModal, setShowSplitBookingModal] = useState(false);
  const [bookingForSplit, setBookingForSplit] = useState(null);
  const [bookingSplitCount, setBookingSplitCount] = useState(1);
  const [maxSplit, setMaxSplit] = useState(1);
  const [bookingSplitRows, setBookingSplitRows] = useState([{
                                                              index: 0,
                                                              container_quantity: 1,
                                                              picked_container: []
                                                            },
                                                          ]);
  const [splitBookingLoader, setSplitBookingLoader] = useState(false);
  const [vesselPlanningRows, setVesselPlanningRows] = useState([]);
  const [bookingPickedContainerList, setBookingPickedContainerList] = useState([]);
                                                          
          

  // ------------------------- Shipment Details ----------------------------
  const [agentList, setAgentList] = useState([]);
  const [portList, setPortList] = useState([]);
  const [selectablePortList, setSelectablePortList] = useState([]);
  const [terminalList, setTerminalList] = useState([]);
  const [principalList, setPrincipalList] = useState([]);
  const [userList, setUserList] = useState([]);
  const [depotList, setDepotList] = useState([]);
  const [containerList, setContainerList] = useState([]);
  const [selectableContainerList, setSelectableContainerList] = useState([]);
  const [cargoList, setCargoList] = useState([]);
  const [operatorList, setOperatorList] = useState([]);
  const [vesselList, setVesselList] = useState([]);
  const [customerList, setCustomerList] = useState([]);
  const [currencyList, setCurrencyList] = useState([]);

  const [showShipmentDetailsModal, setShowShipmentDetailsModal] = useState(false);
  const [shipmentId, setShipmentId] = useState("");
  const [shipmentStatus, setShipmentStatus] = useState("");
  const [bookingNumber, setBookingNumber] = useState("");
  const [principal, setPrincipal] = useState("");
  const [bookingAgent, setBookingAgent] = useState("");
  const [poa, setPoa] = useState("");
  const [pol, setPol] = useState("");
  const [pod, setPod] = useState("");
  const [fd, setFd] = useState("");
  const [transhipmentVesselRoute, setTranshipmentVesselRoute] = useState("");
  const [transhipmentArray, setTranshipmentArray] = useState([]);
  const [bookingParty, setBookingParty] = useState("");
  const [consignee, setConsignee] = useState("");
  const [notifyParty, setNotifyParty] = useState("");
  const [deliveryAgent, setDeliveryAgent] = useState("");
  const [slotOperator, setSlotOperator] = useState("");
  const [bookingLineItem, setBookingLineItem] = useState([]);
  const [cargoType, setCargoType] = useState("");
  const [containerType, setContainerType] = useState("");
  const [cargoName, setCargoName] = useState("");
  const [poaDetentionFreeDays, setPoaDetentionFreeDays] = useState("");
  const [podDetentionFreeDays, setPodDetentionFreeDays] = useState("");
  const [poaTerminalStorageFreeDays, setPoaTerminalStorageFreeDays] = useState("");
  const [podTerminalStorageFreeDays, setPodTerminalStorageFreeDays] = useState("");
  const [transhipmentStorageFreeDays, setTranshipmentStorageFreeDays] = useState("");
  const [exportIhc, setExportIhc] = useState("");
  const [importIhc, setImportIhc] = useState("");
  const [ihcImportPaymentType, setIhcImportPaymentType] = useState("");
  const [ihcExportPaymentType, setIhcExportPaymentType] = useState("");
  const [freightPaymentStatus, setFreightPaymentStatus] = useState("");
  const [fdReleaseApprovalStatus, setFdReleaseApprovalStatus] = useState("");
  const [fdReleaseApprovedBy, setFdReleaseApprovedBy] = useState("");
  const [fdReleaseDate, setFdReleaseDate] = useState("");
  const [switchInvolved, setSwitchInvolved] = useState("");
  const [exportStatus, setExportStatus] = useState("");
  const [salesPerson, setSalesPerson] = useState("");
  const [exportPerson, setExportPerson] = useState("");
  const [importPerson, setImportPerson] = useState("");
  const [transhipmentPerson, setTranshipmentPerson] = useState("");
  const [inTransitTo, setInTransitTo] = useState("");
  const [iecCode, setIecCode] = useState("");
  const [shipper, setShipper] = useState("");
  const [onAccount, setOnAccount] = useState("");
  const [weight, setWeight] = useState("");
  const [blType, setBlType] = useState("");
  const [blSubType, setBlSubType] = useState("");
  const [paymentStaus, setPaymentStatus] = useState("");
  const [shipmentType, setShipmentType] = useState("");
  const [currentDepot, setCurrentDepot] = useState("");
  const [rateApprovedBy, setRateApprovedBy] = useState("");
  const [spaceConfirmedBy, setSpaceConfirmedBy] = useState("");
  const [remarks, setRemarks] = useState("");
  const [shipmentDocumentData, setShipmentDocumentData] = useState([]);
  const [shipmentDocumentDataPending, setShipmentDocumentDataPending] = useState(false);
  const [shipmentHazardousClassInformationData, setShipmentHazardousClassInformationData] = useState([]);
  const [shipmentHazardousClassInformationDataPending, setShipmentHazardousClassInformationDataPending] = useState(false);
  const [vesselTranshipmentLeg, setVesselTranshipmentLeg] = useState([]);
  const [vesselTranshipmentLegPending, setVesselTranshipmentLegPending] = useState([]);

  // ----------------------- Freight --------------------------------
  const [freightChargeData, setFreightChargeData] = useState([]);
  const [showAddFreightModal, setShowAddFreightModal] = useState(false);
  const [showUpdateFreightModal, setShowUpdateFreightModal] = useState(false);
  const [showDeleteFreightModal, setShowDeleteFreightModal] = useState(false);

  const [showAddVesselRouteModal, setShowAddVesselRouteModal] = useState(false);
  const [showUpdateVesselRouteModal, setShowUpdateVesselRouteModal] = useState(false);
  
  const [updateFreightId, setUpdateFreightId] = useState("");
  const [updateFreightType, setUpdateFreightType] = useState("");
  const [updateFreightQuantity, setUpdateFreightQuantity] = useState(1);
  const [updateFreightChargeAmount, setUpdateFreightChargeAmount] = useState(0);
  const [addFreightChargeLoader, setAddFreightChargeLoader] = useState(false);
  const [updateFreightChargeLoader, setUpdateFreightChargeLoader] = useState(false);
  const [deleteFreightChargeLoader, setDeleteFreightChargeLoader] = useState(false);
  const [deleteFreightId, setDeleteFreightId] = useState("");

  // ----------------------- Notes --------------------------------
  const [shipmentNotesData, setShipmentNotesData] = useState([]);
  const [showAddShipmentNotesModal, setShowAddShipmentNotesModal] = useState(false);
  const [showUpdateShipmentNotesModal, setShowUpdateShipmentNotesModal] = useState(false);
  const [showDeleteShipmentNotesModal, setShowDeleteShipmentNotesModal] = useState(false);
  const [updateShipmentNotesId, setUpdateShipmentNotesId] = useState("");
  const [updateShipmentNotesType, setUpdateShipmentNotesType] = useState("");
  const [updateShipmentNote, setUpdateShipmentNote] = useState("");
  const [addShipmentNotesLoader, setAddShipmentNotesLoader] = useState(false);
  const [updateShipmentNotesLoader, setUpdateShipmentNotesLoader] = useState(false);
  const [deleteShipmentNotesLoader, setDeleteShipmentNotesLoader] = useState(false);
  const [deleteShipmentNotesId, setDeleteShipmentNotesId] = useState("");
  const [shipmentNotesDataPending, setShipmentNotesDataPending] = useState(false);
  


  const [activeTab, setActiveTab] = useState("Details");
  const [showBringToDraftLoader, setShowBringToDraftLoader] = useState(false);
  const [showBringToDraftModal, setShowBringToDraftModal] = useState(false);
  const [showCancelBookingLoader, setShowCancelBookingLoader] = useState(false);
  const [showCancelBookingModal, setShowCancelBookingModal] = useState(false);
  const [showReleaseAtFdLoader, setShowReleaseAtFdLoader] = useState(false);
  const [showReleaseAtFdModal, setShowReleaseAtFdModal] = useState(false);
  const [showCloseExportLoader, setShowCloseExportLoader] = useState(false);
  const [showCloseExportModal, setShowCloseExportModal] = useState(false);
  const [miscellaneousChargeList, setMiscellaneousChargeList] = useState([]);
  const [showMiscellaneousChargesModal, setShowMiscellaneousChargesModal] = useState(false);
  const [usdRate, setUSDRate] = useState(0.0);

  // ----------------------- Vessel Route  --------------------------------
  const [vesselRoutePending, setVesselRoutePending] = useState(false);
  const [searchVesselRouteLoader, setSearchVesselRouteLoader] = useState(false);
  const [agreementPickPort, setAgreementPickPort] = useState("");
  const [agreementNextPort, setAgreementNextPort] = useState("");
  const [modeOfTransport, setModeOfTransport] = useState("");
  const [transhipmentAgent, setTranshipmentAgent] = useState("");
  const [agreementSlotOperator, setAgreementSlotOperator] = useState("");
  const [agreementPaymentAgent, setAgreementPaymentAgent] = useState("");
  const [vesselScheduleList, setVesselScheduleList] = useState([]);
  const [slotRateList, setSlotRateList] = useState([]);
  const [shipmentRoute, setShipmentRoute] = useState([]);
  const [showDeleteVesselRouteModal, setShowDeleteVesselRouteModal] = useState(false);
  const [selectedVesselSchedule, setSelectedVesselSchedule] = useState("");
  const [selectedSlotRate, setSelectedSlotRate] = useState("");
  const [routeLeg, setRouteLeg] = useState(1);
  


  const getLoggenInUser = async () => {
    try {
      const response = await axios.get(process.env.REACT_APP_BACKEND_API_URL + '/user/user/' + user_id);
      if (response) {
        setLoggedInUser(response.data)
      }
    } catch (err) {
      toast.error("Error in fetching user data! Try again.");
    }
  }

  const getAgent = async () => {
    try {
      const response = await axios.get(process.env.REACT_APP_BACKEND_API_URL + '/user/agent');
      if (response) {
        const sortedAgents = response.data.sort((a, b) => a.name.localeCompare(b.name));
        setAgentList(sortedAgents)
      }
    } catch (err) {
      toast.error("Error in fetching agent data! Try again.");
    }
  }

  const getPort = async () => {
    try {
      const response = await axios.get(process.env.REACT_APP_BACKEND_API_URL + '/user/port');
      if (response) {
        const sortedPorts = response.data.sort((a, b) => a.name.localeCompare(b.name));
        setPortList(sortedPorts)

        const data = response.data.map(item => ({ value: item.id, label: item.name }));
        const sortedSelectablePorts = [...data].sort((a, b) => a.label.localeCompare(b.label));
        setSelectablePortList(sortedSelectablePorts)
      }
    } catch (err) {
      toast.error("Error in fetching port data! Try again.");
    }
  }

  const getTerminal = async () => {
      try {
        const response = await axios.get(process.env.REACT_APP_BACKEND_API_URL + '/user/terminal');
        if (response) {
          const sortedTerminals = response.data.sort((a, b) => a.name.localeCompare(b.name));
          setTerminalList(sortedTerminals)
        }
      } catch (err) {
        toast.error("Error in fetching port data! Try again.");
      }
    }

  const getPrincipal = async () => {
    try {
      const response = await axios.get(process.env.REACT_APP_BACKEND_API_URL + '/master/principal');
      if (response) {
        const sortedPrincipals = response.data.sort((a, b) => a.name.localeCompare(b.name));
        setPrincipalList(sortedPrincipals)
      }
    } catch (err) {
      toast.error("Error in fetching principal data! Try again.");
    }
  }

  const getUser = async () => {
    try {
      const response = await axios.get(process.env.REACT_APP_BACKEND_API_URL + '/user/user');
      if (response) {
        const sortedUsers = response.data.sort((a, b) => a.name.localeCompare(b.name));
        setUserList(sortedUsers)
      }
    } catch (err) {
      toast.error("Error in fetching user data! Try again.");
    }
  }

  const getDepot = async () => {
    try {
      const response = await axios.get(process.env.REACT_APP_BACKEND_API_URL + '/user/depot');
      if (response) {
        const data = response.data.map(item => ({ value: item.id, label: item.name }));
        const sortedDepots = [...data].sort((a, b) => a.label.localeCompare(b.label));
        // const sortedDepots = response.data.sort((a, b) => a.name.localeCompare(b.name));
        console.log("sortedDepots-------", sortedDepots)
        setDepotList(sortedDepots)
      }
    } catch (err) {
      toast.error("Error in fetching depot data! Try again.");
    }
  }

  const getContainer = async () => {
    try {
      const response = await axios.get(process.env.REACT_APP_BACKEND_API_URL + '/user/product');
      if (response) {
        const sortedContainers = response.data.sort((a, b) => a.product_name.localeCompare(b.product_name));
        setContainerList(sortedContainers)
      }
    } catch (err) {
      toast.error("Error in fetching container data! Try again.");
    }
  }

  const getSelectableContainer = async () => {
    try {
      const response = await axios.get(process.env.REACT_APP_BACKEND_API_URL + '/inventory/container');
      if (response) {
        const data = response.data.map(item => ({ value: item.id, label: item.container_number + " (" + item.type + ") from " + item.current_depot__name, grade: item.grade, location: item.current_location, current_depot: item.current_depot, status: item.status }));
        const sorted_data = [...data].sort((a, b) => a.label.localeCompare(b.label));
        setSelectableContainerList(sorted_data)
      }
    } catch (err) {
      toast.error("Error in fetching container data! Try again.");
    }
  }

  const getCargo = async () => {
    try {
      const response = await axios.get(process.env.REACT_APP_BACKEND_API_URL + '/master/cargo');
      if (response) {
        const sortedCargos = response.data.sort((a, b) => a.name.localeCompare(b.name));
        setCargoList(sortedCargos)
      }
    } catch (err) {
      toast.error("Error in fetching cargo data! Try again.");
    }
  }

  const getVessel = async () => {
    try {
      const response = await axios.get(process.env.REACT_APP_BACKEND_API_URL + '/master/vessel');
      if (response) {
        const sortedVessels = response.data.sort((a, b) => a.name.localeCompare(b.name));
        setVesselList(sortedVessels)
      }
    } catch (err) {
      toast.error("Error in fetching vessel data! Try again.");
    }
  }

  const getCustomer = async () => {
    try {
      const response = await axios.get(process.env.REACT_APP_BACKEND_API_URL + '/user/customer');
      if (response) {
        const sortedCustomers = response.data.sort((a, b) => a.name.localeCompare(b.name));
        setCustomerList(sortedCustomers)
      }
    } catch (err) {
      toast.error("Error in fetching customer data! Try again.");
    }
  }

  const getOperator = async () => {
    try {
      const response = await axios.get(process.env.REACT_APP_BACKEND_API_URL + '/master/operator');
      if (response) {
        const sortedOperators = response.data.sort((a, b) => a.name.localeCompare(b.name));
        setOperatorList(sortedOperators)
      }
    } catch (err) {
      toast.error("Error in fetching operator data! Try again.");
    }
  }

  const getCurrency = async () => {
    try {
      const response = await axios.get(process.env.REACT_APP_BACKEND_API_URL + '/user/currency');
      if (response) {
        const data = response.data.map(item => ({ value: item.id, label: item.symbol + " (" + item.name + ")", current_value: item.current_value, symbol: item.symbol }));
        setCurrencyList(data)
        const current_usd_rate = response.data.find(currency => currency.value === "us_dollar");
        setUSDRate(current_usd_rate?.current_value)
      }
    } catch (err) {
      toast.error("Error in fetching charge data! Try again.");
    }
  }

  const getMiscellaneousCharges = async () => {
    try {
      const response = await axios.get(process.env.REACT_APP_BACKEND_API_URL + '/user/charge?expense_liking=OPTIONAL');
      if (response) {
        const data = response.data.map(item => ({ value: item.id, label: item.display_name, sac_code: item.sac_or_hsn_code, remarks: item.notes, expense_liking: item.expense_liking }));
        const sortedCharges = [...data].sort((a, b) => a.label.localeCompare(b.label));
        setMiscellaneousChargeList(sortedCharges)
      }
    } catch (err) {
      toast.error("Error in fetching miscellaneous charges data! Try again.");
    }
  }


  const getShipment = async (page = 1, size = 10, status) => {
    setDataPending(true)
    setExportOptionStatus(status)
    try {
      const response = await axios.get(process.env.REACT_APP_BACKEND_API_URL + '/master/booking/getexportshipment/?page=' + page+'&status='+status+'&location='+currentSelectedPort);
        if (response) {
          const export_shipment = response.data.results
          console.log("export_shipment", export_shipment)
          setData(export_shipment)
          setCurrentPage(page);
          setTotalData(response.data?.count) 
        }
    } catch (err) {
      toast.error("Error in fetching shipment data! Try again.");
    }
    setDataPending(false)
  }
  
  const getVesselShipment = async (page = 1, size = 10, status) => {
    setDataPending(true)
    setExportOptionStatus(status)
    try {
      const response = await axios.get(process.env.REACT_APP_BACKEND_API_URL + '/master/booking/getvesselwiseshipment/?page=' + page+'&status='+status);
        if (response) {
          console.log("response.data.results", response.data)
          const vessel_shipment = response.data.results

          const processedData = vessel_shipment.map(row => ({
            ...row,
            vessel_arrival: getEtaByPortId(
              row?.vessel?.first_vessel_schedule__schedule_timeline,
              row?.vessel?.vessel_pol
            )
          }));

          setVesselShipmentData(processedData)
          setCurrentPage(page);
          setTotalData(response.data?.count) 
        }
    } catch (err) {
      toast.error("Error in fetching shipment data! Try again.");
    }
    setDataPending(false)
  }

  const getShipmentDocument = async (shipment) => {
    setShipmentDocumentDataPending(true)
    try {
      const response = await axios.get(process.env.REACT_APP_BACKEND_API_URL + '/master/shipmentdocument?booking='+shipment);
      if (response) {
        setShipmentDocumentData(response.data)
      }
    } catch (err) {
      toast.error("Error in fetching shipment document data! Try again.");
    }
    setShipmentDocumentDataPending(false)
  }

  const getShipmentHazardousClassInformation = async (shipment) => {
    setShipmentHazardousClassInformationDataPending(true)
    try {
      const response = await axios.get(process.env.REACT_APP_BACKEND_API_URL + '/master/shipmenthazardousclassinformation?booking='+shipment);
      if (response) {
        setShipmentHazardousClassInformationData(response.data)
      }
    } catch (err) {
      toast.error("Error in fetching shipment hazardous class information data! Try again.");
    }
    setShipmentHazardousClassInformationDataPending(false)
  }

  const filterData = async (e, page = 1, size = 10) => {
    e.preventDefault();
    setDataPending(true)
    setData([])
    const booking_number = filterform.current.booking_number.value
    const cargo_type = filterform.current.cargo_type.value
    const booking_status = filterform.current.booking_status.value
    const payment = filterform.current.payment_type.value
    const sales_person = filterform.current.sales_person.value
    try {
      const response = await axios.get(process.env.REACT_APP_BACKEND_API_URL + '/master/booking/getexportshipment/?page=' + page +
        "&booking_number=" + booking_number + "&cargo_type=" + cargo_type + "&booking_status=" + booking_status +
        "&payment=" + payment + "&sales_person=" + sales_person);

      if (response) {
        const export_shipment = response.data.results
        setData(export_shipment)
        setCurrentPage(page);
        setTotalData(response.data?.count)
        setDataPending(false)
      }
    } catch (err) {
      toast.error("Error in fetching shipment data! Try again.");
    }

  }

  const getSalesUser = async () => {
    try {
      const response = await axios.get(process.env.REACT_APP_BACKEND_API_URL + '/user/user/getsalesuser');
      if (response) {
        setSalesUser(response.data)
      }
    } catch (err) {
      toast.error("Error in fetching sales user data! Try again.");
    }
  }

  const getCurrentUserRolePermission = async (roles) => {
    try {
      const response = await axios.get(process.env.REACT_APP_BACKEND_API_URL + '/user/role/getuserrolepermission?roles=' + roles);

      const role_permissions_array = []
      for (let i = 0; i < response.data.length; i++) {
        for (let j = 0; j < response?.data[i]?.permissions_array.length; j++) {
          if (!role_permissions_array.includes(response?.data[i]?.permissions_array?.[j])) {
            role_permissions_array.push(response?.data[i]?.permissions_array?.[j])
          }
        }
      }

      if (role_permissions_array) {
        setCurrentUserRolePermissionData(role_permissions_array)
      }

    } catch (err) {
      toast.error("Error in fetching user role data! Try again.");
    }
  }

  useEffect(() => {
    getShipment(currentPage, 10, exportOptionStatus)
    getVesselShipment(currentPage, 10, exportOptionStatus)
    getLoggenInUser()
    getSalesUser()
    getAgent()
    getPort()
    getTerminal()
    getPrincipal()
    getUser()
    getDepot()
    getContainer()
    getSelectableContainer()
    getCargo()
    getVessel()
    getCustomer()
    getOperator()
    getMiscellaneousCharges()
    getCurrency()
  }, []);

  const handlePageChange = (page) => {
    getShipment(page, 10, exportOptionStatus);
  };

  const handlePerRowsChange = async (newPerPage, page) => {
    setPerPage(newPerPage);
    getShipment(page, newPerPage, exportOptionStatus);
  };

  useEffect(() => {
    getCurrentUserRolePermission(user_role)
  }, [user_role]);

  const columns = [
    {
      name: 'Booking No.',
      width: '150px',
      selector: row => row.reference_number,
      sortable: true,
    },
    {
      name: 'Route',
      width: '260px',
      selector: row =>
        <>
          <span><b>POA:</b> {row.poa_data?.name}</span><br></br>
          <span><b>POL:</b> {row.pol_data?.name} - {row.pol_terminal_data?.name}</span><br></br>
          <span><b>POD:</b> {row.pod_data?.name}</span><br></br>
          <span><b>FD:</b> {row.fd_data?.name}</span><br></br>
          <span>
            <b>Transhipment: </b>
            {row.transhipment_sequence && Object.values(row.transhipment_sequence)?.length > 0 ? (
              Object.values(row.transhipment_sequence).map(transhipment => (
                <>
                  <br />
                  <span key={transhipment.id}>
                    {transhipment.index} - {transhipment.name}
                  </span>
                </>
              ))
            ) : (
              <span>None</span>
            )}
          </span>
          <hr></hr>
          <span>
            <b>Vessel Schedule: </b>
            {row?.first_vessel_schedule_data?.vessel_data?.name ?
              <span>{row?.first_vessel_schedule_data?.vessel_data?.name} {row?.first_vessel_schedule_data?.voyage} ({row?.first_vessel_schedule_data?.eta_date})</span>
              :
              "None"
            }
          </span><br></br>
        </>,
      sortable: true,
    },
    {
      name: 'Cargo',
      width: '150px',
      selector: row =>
        <>
          <span className={`${row.booking_line_item?.[0]?.cargo_type == "HAZARDOUS" ? "fw-bold bg-danger text-white px-2 rounded" : ""}`}>
            {row.booking_line_item?.[0]?.cargo_type.replaceAll("_", " ")}
          </span><br></br>
          <span>{row.booking_line_item?.[0]?.container_quantity} x {row.booking_line_item?.[0]?.container_type}</span><br></br>
          <span>{row.booking_line_item?.[0]?.commodity}</span><br></br>
          <span>Weight: {Number(row.booking_line_item?.[0]?.weight) + Number(row.booking_line_item?.[0]?.tare_weight)} MT</span>
        </>
    },
    {
      name: 'Stakeholders',
      width: '280px',
      selector: row =>
        <>
          <span><b>Principal:</b> {row.principal_data?.name}</span><br></br>
          <span><b>Booking Agent:</b> {row.booking_agent_data?.name}</span><br></br>
          <span><b>Delivery AGent:</b> {row.delivery_agent_data?.name}</span><br></br>
          <span><b>Shipper:</b> {row.shipper}</span><br></br>
          <span><b>Booking Party:</b> {row.booking_party_data?.name}</span><br></br>
          <span><b>Customer:</b> {row.customer_data?.name}</span><br></br>
          <span><b>Slot Operator:</b> {row.slot_operator_data?.name}</span><br></br>
          <span><b>Slot Payment Agent:</b> {row.slot_payment_agent_data?.name}</span><br></br>
          <span><b>Sales Person:</b> {row.sales_person_data?.name}</span><br></br>
          <span><b>Rate Approved By:</b> {row.rate_approved_by_data?.name}</span><br></br>
          <span><b>Space Confirmed By:</b> {row.space_confirmed_by_data?.name}</span><br></br>
          <span><b>In Transit To:</b> {row.in_transit_to_data?.name}</span>
        </>,
      sortable: true,
    },
    {
      name: 'BL and Schedule',
      width: '160px',
      selector: row =>
        <>
          <span><b>BL Type:</b> {row.bl_type}</span><br></br>
          <span><b>BL Sub Type:</b> {row.bl_sub_type}</span><br></br>
        </>,
      sortable: true,
    },
    {
      name: 'Other Details',
      width: '150px',
      selector: row =>
        <>
          <span><b>IEC Code:</b> {row.iec_code}</span><br></br>
          <span><b>Payment:</b> <span className={`${row.payment == "COLLECT" ? "blink fw-bold bg-inox-green text-white px-2 rounded" : ""}`}>{row.payment}</span></span>
        </>,
      sortable: true,
    },
    {
      name: 'Total Amount',
      width: '150px',
      selector: row =>
        <>
          <span><b>Import Local:</b> {row.total_import_local_amount}</span><br></br>
          <span><b>Export Local:</b> {row.total_export_local_amount}</span>
        </>,
      sortable: true,
    },
    {
      name: 'Status',
      center: true,
      width: '150px',
      selector: row =>
        <div style={{
          borderRadius: 5,
          backgroundColor: row.status === "DRAFT" ? "#B2EBF2" :
            row.status === "WAITING_APPROVAL" ? "#FFF3CD" :
              row.status === "APPROVED" ? "#C3E6CB" :
                row.status === "NOT_APPROVED" ? "#FFE5B4" :
                  row.status === "REJECTED" ? "#F5C6CB" :
                    row.status === "CANCELLED" ? "#D6D8DB" : "#000"
        }}>
          <p className="px-3 my-2 fw-bold">{row.status?.replaceAll("_", " ")}</p>
        </div>,
      sortable: true,
    },
    {
      name: 'Action',
      center: true,
      width: '100px',
      selector: row => <div>
        <Button className="btn btn-sm btn-inox-green border-0 mr-2" title="View" onClick={() => handleShipmentDetails(row)}>
          <i className="fa fa-eye"></i>
        </Button>

        <Button className={`btn btn-sm ${row?.shipment_container > 1?"btn-warning":"btn-secondary"} border-0`} title="Split Booking" onClick={() => handleSplitBooking(row)} disabled={row?.shipment_container > 1?false:true}>
          <i className="fa fa-random"></i>
        </Button>
      </div>,
    }
  ];

  const handleSplitBooking = (data) => {
    setBookingForSplit(data)
    setBookingSplitRows([{
                          index: 0,
                          container_quantity: parseInt(data?.shipment_container),
                          picked_container: []
                        },
                      ]);
    setShowSplitBookingModal(true)

    const picked_container = data?.booking_picked_container
    console.log("picked_container 00000000000000", picked_container)

    if(picked_container){
      const picked_data = picked_container.map(item => ({ value: item.container.id, label: item.container.container_number }));
      console.log("picked_data 00000000000000", picked_data)

      setBookingPickedContainerList(picked_data)
    }
  }

  const generateBookingSplitRows = (count) => {
    setBookingSplitRows([{
                          index: 0,
                          container_quantity: parseInt(bookingForSplit?.shipment_container),
                          picked_container: parseInt(bookingForSplit?.shipment_container),
                        },
                      ]);

    let split_array = []
    for (let i = 0; i < count; i++) {
      split_array.push({
        index: i,
        container_quantity: i == 0? bookingForSplit?.shipment_container: 0,
        picked_container: []
      });
    }

    setBookingSplitRows(split_array)
    console.log("split_array---------", split_array)
  }

  // const handleContainerSplit = (index, count, container) => {
  //   const picked_container_array = bookingSplitRows.map(row => row.picked_container)
  //   const updated_container_list = bookingPickedContainerList.filter(container => !picked_container_array.includes(container));
  //   setBookingPickedContainerList(updated_container_list)

  //   bookingSplitRows[index]['container_quantity'] = parseInt(count)
  //   bookingSplitRows[index]['picked_container'] = container

  //   const split_containers = bookingSplitRows.reduce((total, item) => {
  //                                                                     if (item.index !== 0) {
  //                                                                       return total + (parseInt(item.container_quantity) || 0);
  //                                                                     }
  //                                                                     return total;
  //                                                                   }, 0);

  //   let first_booking_container = bookingForSplit?.shipment_container - split_containers
  //   bookingSplitRows[0]['container_quantity'] = first_booking_container

  //   // Add Temp element in array at the end and remove it immediately. This works as a refresh
  //   bookingSplitRows.push({ index: bookingSplitRows.length, container_quantity: 0, picked_container: null });
  //   setBookingSplitRows(prev => prev.slice(0, -1))
    
  //   console.log("bookingSplitRows 00000000", bookingSplitRows)
  // }

  const handleContainerSplit = (index, count, container) => {
    const prevContainer = bookingSplitRows[index]?.picked_container;

    if (!container && prevContainer) {
      setBookingPickedContainerList(prev => [...prev, prevContainer]);
    }

    if (container && prevContainer && container.value !== prevContainer.value) {
      setBookingPickedContainerList(prev => [...prev, prevContainer]);
    }

    if (container) {
      setBookingPickedContainerList(prev =>
        prev.filter(item => item.value !== container.value)
      );
    }

    const updatedRows = [...bookingSplitRows];

    updatedRows[index] = {
      ...updatedRows[index],
      index: index, // fix
      container_quantity: parseInt(count),
      picked_container: container
    };

    const split_containers = updatedRows.reduce((total, item) => {
      if (item.index !== 0) {
        return total + (parseInt(item.container_quantity) || 0);
      }
      return total;
    }, 0);

    let first_booking_container =
      bookingForSplit?.shipment_container - split_containers;

    updatedRows[0].container_quantity = first_booking_container;

    setBookingSplitRows(updatedRows);
  };

  const split_booking = async () => {
    setSplitBookingLoader(true)
    const data = {
      "existing_booking": bookingForSplit.id,
      "split_obj": bookingSplitRows
    }

    try {
      const response = await axios.put(process.env.REACT_APP_BACKEND_API_URL + '/master/booking/splitbooking/', data, { headers: { 'content-type': 'application/json' } });

      if (response.status == 200) {
        toast.success("Booking Split Successfully")
      }
      getShipment(currentPage, 10, exportOptionStatus)
    } catch (err) {
      toast.error("Error in splitting this booking! Try again.");
    }

    setShowSplitBookingModal(false)
    setSplitBookingLoader(false)
  }

  const [visibleCols, setVisibleCols] = useState(columns);

  const toggleColumn = (colName) => {
    let updatedCols;

    if (visibleCols.some(c => c.name === colName)) {
      updatedCols = visibleCols.filter(c => c.name !== colName);
    } else {
      updatedCols = [...visibleCols, columns.find(c => c.name === colName)];
    }

    const sortedCols = columns.filter(col =>
      updatedCols.some(vc => vc.name === col.name)
    );

    setVisibleCols(sortedCols);
  };


  const gridcolumns = [
    {
      name: 'Booking No.',
      width: '150px',
      selector: row => row.reference_number,
      sortable: true,
    },
    {
      name: 'POA',
      width: '80px',
      selector: row => row.poa_data?.ita_code,
      sortable: true,
    },
    {
      name: 'POL',
      width: '80px',
      selector: row => row.pol_data?.ita_code,
      sortable: true,
    },
    {
      name: 'POD',
      width: '80px',
      selector: row => row.pod_data?.ita_code,
      sortable: true,
    },
    {
      name: 'FD',
      width: '80px',
      selector: row => row.fd_data?.ita_code,
      sortable: true,
    },
    {
      name: 'Transhipment',
      width: '180px',
      selector: row => row.transhipment_sequence && Object.values(row.transhipment_sequence)?.length > 0 ? (
                  Object.values(row.transhipment_sequence).map(transhipment => (
                    <>
                      <span key={transhipment.id}>
                        {transhipment.index} - {transhipment.name}
                      </span>
                      <br></br>
                    </>
                  ))
                ) : (
                  <span>None</span>
                ),
      sortable: true,
    },
    {
      name: 'Vessel',
      width: '200px',
      selector: row => <>
                {row?.first_vessel_schedule_data?.vessel_data?.name ?
                  <span>{row?.first_vessel_schedule_data?.vessel_data?.name}</span>
                  :
                  "None"
                }</>,
      sortable: true,
    },
    {
      name: 'Voyage',
      width: '100px',
      selector: row => <>
                {row?.first_vessel_schedule_data?.vessel_data?.name ?
                  <span>{row?.first_vessel_schedule_data?.voyage}</span>
                  :
                  "None"
                }</>,
      sortable: true,
    },
    {
      name: 'ETA',
      width: '100px',
      selector: row => <>
                {row?.first_vessel_schedule_data?.vessel_data?.name ?
                  <span>{row?.first_vessel_schedule_data?.eta_date}</span>
                  :
                  "None"
                }</>,
      sortable: true,
    },
    {
      name: 'Cargo Type',
      width: '150px',
      selector: row => <>
              <span className={`${row.booking_line_item?.[0]?.cargo_type == "HAZARDOUS" ? "fw-bold bg-danger text-white px-2 rounded" : ""}`}>
                {row.booking_line_item?.[0]?.cargo_type.replaceAll("_", " ")}
              </span><br></br></>,
      sortable: true,
    },
    {
      name: 'Container Type',
      width: '130px',
      selector: row => row.booking_line_item?.[0]?.container_type,
      sortable: true,
    },
    {
      name: 'Quantity',
      width: '100px',
      selector: row => row.booking_line_item?.[0]?.container_quantity,
      sortable: true,
    },

    {
      name: 'Commodity',
      width: '180px',
      selector: row => row.booking_line_item?.[0]?.commodity,
      sortable: true,
    },
    {
      name: 'Weight',
      width: '100px',
      selector: row => <span>{Number(row.booking_line_item?.[0]?.weight) + Number(row.booking_line_item?.[0]?.tare_weight)} MT</span>,
      sortable: true,
    },
    {
      name: 'Principal',
      width: '150px',
      selector: row => row.principal_data?.name,
      sortable: true,
    },
    {
      name: 'Booking Agent',
      width: '150px',
      selector: row => row.booking_agent_data?.name,
      sortable: true,
    },
    {
      name: 'Delivery Agent',
      width: '150px',
      selector: row => row.delivery_agent_data?.name,
      sortable: true,
    },
    {
      name: 'Shipper',
      width: '150px',
      selector: row => row.shipper,
      sortable: true,
    },
    {
      name: 'Booking Party',
      width: '150px',
      selector: row => row.booking_party_data?.name,
      sortable: true,
    },
    {
      name: 'Customer',
      width: '150px',
      selector: row => row.customer_data?.name,
      sortable: true,
    },
    {
      name: 'Slot Operator',
      width: '150px',
      selector: row => row.slot_operator_data?.name,
      sortable: true,
    },
    {
      name: 'Slot Payment Agent',
      width: '180px',
      selector: row => row.slot_payment_agent_data?.name,
      sortable: true,
    },
    {
      name: 'Sales Person',
      width: '150px',
      selector: row => row.sales_person_data?.name,
      sortable: true,
    },
    {
      name: 'Rate Approved By',
      width: '180px',
      selector: row => row.rate_approved_by_data?.name,
      sortable: true,
    },
    {
      name: 'Space Confirmed By',
      width: '180px',
      selector: row => row.space_confirmed_by_data?.name,
      sortable: true,
    },
    {
      name: 'In Transit To',
      width: '180px',
      selector: row => row.in_transit_to_data?.name,
      sortable: true,
    },
    {
      name: 'BL Type',
      width: '120px',
      selector: row => row.bl_type,
      sortable: true,
    },
    {
      name: 'BL Sub Type',
      width: '120px',
      selector: row => row.bl_sub_type,
      sortable: true,
    },
    {
      name: 'IEC Code',
      width: '120px',
      selector: row => row.iec_code,
      sortable: true,
    },
    {
      name: 'Payment',
      width: '120px',
      selector: row => <span className={`${row.payment == "COLLECT" ? "blink fw-bold bg-inox-green text-white px-2 rounded" : ""}`}>{row.payment}</span>,
      sortable: true,
    },
    {
      name: 'Import Local',
      width: '120px',
      selector: row => row.total_import_local_amount,
      sortable: true,
    },
    {
      name: 'Export Local',
      width: '120px',
      selector: row => row.total_export_local_amount,
      sortable: true,
    },
    {
      name: 'Status',
      width: '150px',
      selector: row => <div style={{
              borderRadius: 5,
              backgroundColor: row.status === "DRAFT" ? "#B2EBF2" :
                row.status === "WAITING_APPROVAL" ? "#FFF3CD" :
                  row.status === "APPROVED" ? "#C3E6CB" :
                    row.status === "NOT_APPROVED" ? "#FFE5B4" :
                      row.status === "REJECTED" ? "#F5C6CB" :
                        row.status === "CANCELLED" ? "#D6D8DB" : "#000"
            }}>
              <p className="px-3 my-2 fw-bold">{row.status?.replaceAll("_", " ")}</p>
            </div>,
      sortable: true,
    },
    {
      name: 'Action',
      center: true,
      width: '100px',
      selector: row => <div>
        <Button className="btn btn-sm btn-inox-green border-0" title="View" onClick={() => handleShipmentDetails(row)}>
          <i className="fa fa-eye"></i>
        </Button>
      </div>,
    }
  ]

  const [visibleGridCols, setVisibleGridCols] = useState(gridcolumns);

  const toggleGridColumn = (colName) => {
    let updatedGridCols;

    if (visibleGridCols.some(c => c.name === colName)) {
      updatedGridCols = visibleGridCols.filter(c => c.name !== colName);
    } else {
      updatedGridCols = [...visibleGridCols, gridcolumns.find(c => c.name === colName)];
    }

    const sortedGridCols = gridcolumns.filter(col =>
      updatedGridCols.some(vc => vc.name === col.name)
    );

    setVisibleGridCols(sortedGridCols);
  };


  // const vesselshipmentcolumns = [
  //   {
  //     name: 'Vessel',
  //     selector: row => <>
  //               {row?.vessel?.first_vessel_schedule__vessel__name ?
  //                 <table>
  //                   <tr>
  //                     <td style={{ width: '300px'}}>{row?.vessel?.first_vessel_schedule__vessel__name}</td>
  //                     <td style={{ width: '200px'}}><b>Voyage:</b> {row?.vessel?.first_vessel_schedule__voyage}</td>
  //                     <td style={{ width: '250px'}}>
  //                       <b>ETA: </b> {row?.vessel?.first_vessel_schedule__schedule_timeline?.[0]?.eta ? format(parseISO(row?.vessel?.first_vessel_schedule__schedule_timeline?.[0]?.eta), "dd/MM/yyyy, hh:mm a"): ""}
  //                     </td>
  //                     <td style={{ width: '250px'}}>
  //                       <b>Gate Open: </b> {row?.vessel?.first_vessel_schedule__schedule_timeline?.[0]?.gate_open ? format(parseISO(row?.vessel?.first_vessel_schedule__schedule_timeline?.[0]?.gate_open), "dd/MM/yyyy, hh:mm a"):""}
  //                     </td>
  //                     <td>
  //                       <b>Location: </b> {row?.vessel?.first_vessel_schedule__schedule_timeline?.[0]?.name} ({row?.vessel?.first_vessel_schedule__schedule_timeline?.[0]?.terminal_name})
  //                     </td>
  //                   </tr>
  //                 </table>
  //                 :
  //                 "None"
  //               }</>,
  //     sortable: true,
  //   },
  // ]

  const getEtaByPortId = (timeline, portId) => {
    const port = timeline.find(p => p.port_id == portId);
    return port ? port.eta : null;
  };

  const getGateOpenByPortId = (timeline, portId) => {
    const port = timeline.find(p => p.port_id == portId);
    return port ? port.gate_open : null;
  };

  const getPortByPortId = (timeline, portId) => {
    const port = timeline.find(p => p.port_id == portId);
    return port ? port.name : null;
  };

  const getTerminalByPortId = (timeline, portId) => {
    const port = timeline.find(p => p.port_id == portId);
    return port ? port.terminal_name : null;
  };

  const vesselShipmentConditionalRowStyles = {
    table: {
      style: {
        marginTop: '10px',
      }
    },
    headRow: {
      style: {
        fontSize: '12px',
        color: '#FFF',
        fontWeight: 'bold',
        backgroundColor: '#12708C',
        borderRadius: '5px 5px 0px 0px',
      },
    },
    rows: {
      when: row => row.vessel?.total_tonnage > row.vessel?.first_vessel_schedule__max_tonnage,
      style: {
        height: '65px',
        fontSize: '12px',
        backgroundColor: "#DC3545",
      },
      when: row => row.vessel?.total_tonnage < row.vessel?.first_vessel_schedule__max_tonnage,
      style: {
        height: '65px',
        fontSize: '12px',
        backgroundColor: "#FFC107",
      }
    },
    pagination: {
      style: {
        borderRadius: '0px 0px 5px 5px'
      }
    }
  }

  const vesselshipmentcolumns = [
    {
      id: 'eta',
      name: 'Vessel',
      width: '1150px',
      selector: row => (
        <>
          {row?.vessel?.first_vessel_schedule__vessel__name ? (
            <table>
              <tr>
                <td style={{ width: '200px' }}>
                  {row?.vessel?.first_vessel_schedule__vessel__name}
                </td>
                <td style={{ width: '150px' }}>
                  <b>Voyage:</b> {row?.vessel?.first_vessel_schedule__voyage}
                </td>
                <td style={{ width: '250px' }}>
                  <b>ETA: </b>
                  {getEtaByPortId(row?.vessel?.first_vessel_schedule__schedule_timeline, row?.vessel?.vessel_pol) 
                    ? format(
                        parseISO(
                          getEtaByPortId(row?.vessel?.first_vessel_schedule__schedule_timeline, row?.vessel?.vessel_pol)
                        ),
                        'dd/MM/yyyy, hh:mm a'
                      )
                    : ''}
                </td>
                <td style={{ width: '250px' }}>
                  <b>Gate Open: </b>
                  {getGateOpenByPortId(row?.vessel?.first_vessel_schedule__schedule_timeline, row?.vessel?.vessel_pol)
                    ? format(
                        parseISO(
                          getGateOpenByPortId(row?.vessel?.first_vessel_schedule__schedule_timeline, row?.vessel?.vessel_pol)
                        ),
                        'dd/MM/yyyy, hh:mm a'
                      )
                    : ''}
                </td>
                <td style={{ width: '250px' }}>
                  <b>Location: </b>
                  {getPortByPortId(row?.vessel?.first_vessel_schedule__schedule_timeline, row?.vessel?.vessel_pol)} ({getTerminalByPortId(row?.vessel?.first_vessel_schedule__schedule_timeline, row?.vessel?.vessel_pol)})
                </td>
              </tr>
            </table>
          ) : (
            'None'
          )}
        </>
      ),
      sortable: true,

      sortFunction: (a, b) => {
        const etaA = getEtaByPortId(a?.vessel?.first_vessel_schedule__schedule_timeline, a?.vessel?.vessel_pol);

        const etaB = getEtaByPortId(b?.vessel?.first_vessel_schedule__schedule_timeline, b?.vessel?.vessel_pol);

        console.log("etaA00000000000000000", etaA)
        console.log("etaB00000000000000000", etaB)

        if (!etaA && !etaB) return 0;
        if (!etaA) return 1;
        if (!etaB) return -1;

        return new Date(etaA) - new Date(etaB);
      },
    },
    {
      id: 'tonnage',
      name: 'Tonnage',
      width: '150px',
      selector: row => <>
                        <b>{row.vessel?.total_tonnage}</b> / <span>{row.vessel?.first_vessel_schedule__max_tonnage} MT</span>
                      </>
    },
    {
      id: 'containers_count',
      name: 'Container',
      width: '100px',
      selector: row => row.vessel?.total_containers
    }
  ];



  const ExpandedVesselShipmentComponent = ({ data }) => {

    const vesselshipmentcolumns = [
      {
        name: 'Booking No.',
        width: '150px',
        selector: row => row.reference_number,
        sortable: true,
      },
      {
        name: 'POA',
        width: '80px',
        selector: row => row.poa_data?.ita_code,
        sortable: true,
      },
      {
        name: 'POL',
        width: '80px',
        selector: row => row.pol_data?.ita_code,
        sortable: true,
      },
      {
        name: 'POD',
        width: '80px',
        selector: row => row.pod_data?.ita_code,
        sortable: true,
      },
      {
        name: 'FD',
        width: '80px',
        selector: row => row.fd_data?.ita_code,
        sortable: true,
      },
      {
        name: 'Transhipment',
        width: '180px',
        selector: row => row.transhipment_sequence && Object.values(row.transhipment_sequence)?.length > 0 ? (
                    Object.values(row.transhipment_sequence).map(transhipment => (
                      <>
                        <span key={transhipment.id}>
                          {transhipment.index} - {transhipment.name}
                        </span>
                        <br></br>
                      </>
                    ))
                  ) : (
                    <span>None</span>
                  ),
        sortable: true,
      },
      {
        name: 'Cargo Type',
        width: '150px',
        selector: row => <>
                <span className={`${row.booking_line_item?.[0]?.cargo_type == "HAZARDOUS" ? "fw-bold bg-danger text-white px-2 rounded" : ""}`}>
                  {row.booking_line_item?.[0]?.cargo_type.replaceAll("_", " ")}
                </span><br></br></>,
        sortable: true,
      },
      {
        name: 'Commodity',
        width: '180px',
        selector: row => row.booking_line_item?.[0]?.commodity,
        sortable: true,
      },
      {
        name: 'Container Type',
        width: '130px',
        selector: row => row.booking_line_item?.[0]?.container_type,
        sortable: true,
      },
      {
        name: 'Quantity',
        width: '100px',
        selector: row => row.booking_line_item?.[0]?.container_quantity,
        sortable: true,
      },
      {
        name: 'Weight',
        width: '100px',
        selector: row => <span>{(row.booking_line_item?.[0]?.container_quantity * (Number(row.booking_line_item?.[0]?.weight) + Number(row.booking_line_item?.[0]?.tare_weight))).toFixed(2)} MT</span>,
        sortable: true,
      },
      {
        name: 'Principal',
        width: '150px',
        selector: row => row.principal__name ?? "-",
        sortable: true,
      },
      {
        name: 'Booking Agent',
        width: '150px',
        selector: row => row.booking_agent__name ?? "-",
        sortable: true,
      },
      {
        name: 'Delivery Agent',
        width: '150px',
        selector: row => row.delivery_agent__name ?? "-",
        sortable: true,
      },
      {
        name: 'Shipper',
        width: '150px',
        selector: row => row.shipper ?? "-",
        sortable: true,
      },
      {
        name: 'Booking Party',
        width: '150px',
        selector: row => row.booking_party__name ?? "-",
        sortable: true,
      },
      {
        name: 'Customer',
        width: '150px',
        selector: row => row.customer__name ?? "-",
        sortable: true,
      },
      {
        name: 'Slot Operator',
        width: '150px',
        selector: row => row.slot_operator__name ?? "-",
        sortable: true,
      },
      {
        name: 'Slot Payment Agent',
        width: '180px',
        selector: row => row.slot_payment_agent__name ?? "-",
        sortable: true,
      },
      {
        name: 'Sales Person',
        width: '150px',
        selector: row => row.sales_person__name ?? "-",
        sortable: true,
      },
      {
        name: 'Rate Approved By',
        width: '180px',
        selector: row => row.rate_approved_by__name ?? "-",
        sortable: true,
      },
      {
        name: 'Space Confirmed By',
        width: '180px',
        selector: row => row.space_confirmed_by__name ?? "-",
        sortable: true,
      },
      {
        name: 'In Transit To',
        width: '180px',
        selector: row => row.in_transit_to__name ?? "-",
        sortable: true,
      },
      {
        name: 'BL Type',
        width: '120px',
        selector: row => row.bl_type ?? "-",
        sortable: true,
      },
      {
        name: 'BL Sub Type',
        width: '120px',
        selector: row => row.bl_sub_type ?? "-",
        sortable: true,
      },
      {
        name: 'IEC Code',
        width: '120px',
        selector: row => row.iec_code ?? "-",
        sortable: true,
      },
      {
        name: 'Payment',
        width: '120px',
        selector: row => <span className={`${row.payment == "COLLECT" ? "blink fw-bold bg-inox-green text-white px-2 rounded" : ""}`}>{row.payment}</span>,
        sortable: true,
      },
      {
        name: 'Import Local',
        width: '120px',
        selector: row => row.total_import_local_amount ?? 0,
        sortable: true,
      },
      {
        name: 'Export Local',
        width: '120px',
        selector: row => row.total_export_local_amount ?? 0,
        sortable: true,
      },
      {
        name: 'Status',
        width: '150px',
        selector: row => <div style={{
                borderRadius: 5,
                backgroundColor: row.status === "DRAFT" ? "#B2EBF2" :
                  row.status === "WAITING_APPROVAL" ? "#FFF3CD" :
                    row.status === "APPROVED" ? "#C3E6CB" :
                      row.status === "NOT_APPROVED" ? "#FFE5B4" :
                        row.status === "REJECTED" ? "#F5C6CB" :
                          row.status === "CANCELLED" ? "#D6D8DB" : "#000"
              }}>
                <p className="px-3 my-2 fw-bold">{row.status?.replaceAll("_", " ")}</p>
              </div>,
        sortable: true,
      },
      {
        name: 'Action',
        center: true,
        width: '100px',
        selector: row => <div>
          <Button className="btn btn-sm btn-inox-green border-0" title="View" onClick={() => handleShipmentDetails(row.shipment_data)}>
            <i className="fa fa-eye"></i>
          </Button>
        </div>,
      }
    ];

    return (
      <div className="col-12 text-left" style={{ marginTop: -10, paddingLeft: 48, paddingRight: 0, zIndex: 100 }}>
        <DataTable
          columns={vesselshipmentcolumns}
          data={data?.shipments || []}
          progressPending={dataPending}
          progressComponent={<Spinner className="mx-5 text-inox-green table-spinner" as="span" animation="border" size="lg" role="status" aria-hidden="true" />}
          noDataComponent={<p className="text-center table-no-data">No Data Found</p>}
          highlightOnHover
          customStyles={vesselWiseBookingCustomStyles}
          dense
        />
      </div>
    )
  }

  const getVesselScheduleTranshipmentPort = async (pol, pod, transhipment, operator, agent, container_type, cargo_type, quantity) => {
    setVesselTranshipmentLegPending(true)
    if (pol != "" | pol != undefined) {
      if (pod != "" | pod != undefined) {
        try {
          const transhipment_port_response = await axios.get(process.env.REACT_APP_BACKEND_API_URL + '/master/vesselschedule/gettranshipmentvesselroute?pick_port=' + pol + 
            '&next_port=' + pod + '&transhipment=' + transhipment + '&operator=' + operator + '&agent=' + agent + '&container_type=' + container_type + '&cargo_type=' + cargo_type + '&quantity=' + quantity)
            
          if(transhipment_port_response){
            setVesselTranshipmentLeg(transhipment_port_response?.data[0])
            // setTranshipmentStorageFreeDays(transhipment_port_response?.data?.transhipment_storage_free_days)
          }
        } catch (err) {
          toast.error("Error in fetching transhipment leg data! Try again.", err);
        }
      }
    }
    setVesselTranshipmentLegPending(false)
  }

  const handleShipmentDetails = (data) => {
    console.log("data---------", data)
    
    setShowShipmentDetailsModal(true)
    setShipmentId(data?.id)
    setShipmentStatus(data?.status)
    // ------------- Route ---------------------
    setBookingNumber(data?.reference_number)

    setBookingAgent(data?.booking_agent_data)
    setPoa(data?.poa_data)
    setPol(data?.pol_data)
    setPod(data?.pod_data)
    setFd(data?.fd_data)
    setShipmentType(data?.shipment_type)
    setTranshipmentVesselRoute(data?.transhipment_vessel_route)
    setTranshipmentArray(data?.transhipment)

    // --------------- Stakeholders ------------------
    setPrincipal(data?.principal_data)
    setBookingParty(data?.booking_party_data)
    setDeliveryAgent(data?.delivery_agent_data)
    setSlotOperator(data?.slot_operator_data)
    setSalesPerson(data?.sales_person_data)
    setShipper(data?.shipper)
    setOnAccount(data?.on_account)
    setExportPerson("")
    setImportPerson("")
    setTranshipmentPerson("")

    // --------------- Logistic Partners ------------------
    setRateApprovedBy(data?.rate_approved_by_data)
    setSpaceConfirmedBy(data?.space_confirmed_by_data)

    // Cargo and Container -------------------------
    setBookingLineItem(data?.booking_line_item)
    setCargoType(data?.booking_line_item?.[0]?.cargo_type)
    setContainerType(data?.booking_line_item?.[0]?.container_type)

    // Free Days-------------------------------------
    setPoaDetentionFreeDays(data?.poa_detention_free_days)
    setPodDetentionFreeDays(data?.pod_detention_free_days)
    setPoaTerminalStorageFreeDays(data?.poa_terminal_storage_free_days)
    setPodTerminalStorageFreeDays(data?.pod_terminal_storage_free_days)
    // setTranshipmentStorageFreeDays(data?.transhipment_terminal_storage_free_days)

    // ------------- Charges ------------------------
    setExportIhc("")
    setImportIhc("")
    setIhcImportPaymentType(data?.ihc_import_payment_type)
    setIhcExportPaymentType(data?.ihc_export_payment_type)
    setFreightPaymentStatus("")

    setFdReleaseApprovalStatus("")
    setFdReleaseApprovedBy("")
    setFdReleaseDate("")

    // ------------ Bill of Lading -----------------------
    setBlType(data?.bl_type)
    setBlSubType(data?.bl_sub_type)
    setSwitchInvolved(data?.bl_sub_type == "NA" ? "NO" : "YES")
    setExportStatus("")

    setInTransitTo("")
    setIecCode(data?.customer_data?.iec_code)
    setWeight(data?.total_tonnage)
    setPaymentStatus(data?.payment)

    setCurrentDepot("")
    setRemarks(data?.remarks)
    getShipmentDocument(data?.id)
    getShipmentHazardousClassInformation(data?.id)

    const container_type = data?.booking_line_item?.[0]?.container_type
    const cargo_type = data?.booking_line_item?.[0]?.cargo_type
    const quantity = data?.booking_line_item?.[0]?.container_quantity
    getVesselScheduleTranshipmentPort(data?.pol_data?.id, data?.pod_data?.id, data?.transhipment, data?.slot_operator_data?.id, data?.booking_agent_data?.id, container_type, cargo_type, quantity)

    const freight = [{
      "index": 1,
      "type": container_type,
      "quantity": quantity,
      "freight": data?.freight_charge
    }]
    
    getFreightCharges(data?.id)
    setMiscellaneousChargeRows(data?.miscellaneous_charge)
    updateCalculateSlot(data?.booking_line_item, data?.vessel_planning)
  }

  const updateCalculateSlot = async (updateBookingLineItem, vesselPlanningRows) => {
    if(updateBookingLineItem && Object.keys(vesselPlanningRows || {}).length != 0){
      var total_slot_rate = 0
      for (let i=0; i<updateBookingLineItem.length; i++){
        var quantity = parseInt(updateBookingLineItem?.[i]?.['container_quantity'] ?? updateBookingLineItem?.[i]?.['quantity'])

        for (let j=0; j<vesselPlanningRows?.[0]?.[i].length; j++){
          var slot = parseFloat(vesselPlanningRows?.[0]?.[i]?.[j]['slot']) ?? 0
          total_slot_rate += quantity * slot
        }
      }

      const response = await axios.get(process.env.REACT_APP_BACKEND_API_URL + '/master/transhipment/getupdatetranshipmentcharge?cargo='+ JSON.stringify(updateBookingLineItem) +'&vessel_plan=' + JSON.stringify(vesselPlanningRows[0]));
      // setTotalTranshipmentCharge(response.data)
      setTranshipmentStorageFreeDays(response.data?.transhipment_port_free_days)

      // setTotalSlotRate(total_slot_rate)
      setVesselPlanningRows(vesselPlanningRows)
    }
  }


  //  ----------------------------------------------- Shipment Documents  -----------------------------------------------------
  const shipmentdocumentcolumns = [
    {
      name: 'Preview',
      selector: row =>
        <>
          {row.file_type == 'application/pdf' ?
            <img className="img" style={{ border: '1px solid lightgrey' }} src={`${row.screenshot}`} width={100}></img>
            :
            <img className="img" style={{ border: '1px solid lightgrey' }} src={`${row.file}`} width={100}></img>
          }
        </>
      ,
      width: '150px',
      sortable: true,
    },
    {
      name: 'File Name',
      selector: row => row.file_name,
      width: '300px',
      sortable: true,
    },
    {
      name: 'Document Category',
      selector: row => row.document_category.replaceAll("_", " "),
      sortable: true,
    },
    {
      name: 'File Type',
      selector: row => row.file_type,
      sortable: true,
    },
    {
      name: 'File Size',
      selector: row => row.file_size + " MB",
      sortable: true,
    },
    {
      name: 'Uploaded By',
      selector: row => row.created_by?.name,
      sortable: true,
    },
    {
      name: 'Action',
      center: true,
      selector: row => <div>
        {
          currentUserRolePermissionData?.includes("draftbooking:draftbookingrequest:view") ?
            <a href={`${row.file}`} target="_blank">
              <Button className="btn btn-sm btn-inox-geen border-0 mx-2" title="View">
                <i className="fa fa-eye"></i>
              </Button>
            </a>
            :
            ""
        }
      </div>,
    }
  ];

  const shipmenthazardousclasscolumns = [
    {
      name: 'Class',
      selector: row => row.haz_class,
      sortable: true,
    },
    {
      name: 'UN No',
      selector: row => row.un_number,
      sortable: true,
    },
    {
      name: 'Packaging Group',
      selector: row => row.packaging_group,
      sortable: true,
    },
    {
      name: 'EMS/PSA Group',
      selector: row => row.ems_psa_group,
      sortable: true,
    },
    {
      name: 'Marine Pollutant',
      selector: row => row.marine_pollutant,
      sortable: true,
    },
    {
      name: 'Flash Point',
      selector: row => row.flash_point,
      sortable: true,
    },
    {
      name: 'Segregation Group',
      selector: row => row.segregation_group,
      sortable: true,
    },
    {
      name: 'Packing Code',
      selector: row => row.un_packing_code,
      sortable: true,
    },
    {
      name: 'Sub Risk Label',
      selector: row => row.sub_risk_label,
      sortable: true,
    }
  ];

  const transhipmentlegcolumns = [
    {
      name: 'Leg',
      selector: (row, index) => index + 1,
      width: '70px',
      sortable: true,
    },
    {
      name: 'Pickup',
      selector: row => row.from_port,
      width: '250px',
      sortable: true,
    },
    {
      name: 'Next',
      selector: row => row.to_port,
      width: '250px',
      sortable: true,
    },
    {
      name: 'Type',
      selector: row => row.type,
      width: '90px',
      sortable: true,
    },
    {
      name: 'Vessel',
      selector: row => row.schedule.vessel,
      width: '250px',
      sortable: true,
    },
    {
      name: 'Voyage',
      selector: row => row.schedule.voyage,
      width: '100px',
      sortable: true,
    },
    {
      name: 'ETA',
      selector: row => row?.eta ? format(parseISO(row.eta), "dd/MM/yyyy, hh:mm a") : "-",
      width: '200px',
      sortable: true,
    },
    {
      name: 'ETD',
      selector: row => row?.etd ? format(parseISO(row.etd), "dd/MM/yyyy, hh:mm a") : "-",
      width: '200px',
      sortable: true,
    },
    {
      name: 'Slot',
      selector: row => row.slot,
      sortable: true,
    },
    {
      name: 'Action',
      width: '110px',
      center: true,
      selector: (row, index) =>
        <div>
          <Button className="btn btn-sm btn-inox-green border-0 my-1" style={{ height: 30 }} title="Update" 
            onClick={() => handleVesselRoutePlanning(index+1, row.schedule_id, row.from, row.from_port, row.to, row.to_port, row.schedule.vessel_type)}>
            <i className="fa fa-edit"></i>
          </Button>

          <Button className="btn btn-sm btn-danger my-1 mx-1" style={{ height: 30 }} title="Delete" onClick={() => setShowDeleteVesselRouteModal(row)}>
            <i className="fa fa-trash"></i>
          </Button>
        </div>,
    }
  ];

  const shipmentfreightcolumns = [
    {
      name: 'Sr',
      selector: (row, index) => index + 1,
      sortable: true,
    },
    {
      name: 'Type',
      selector: row => row.type_data?.product_name,
      sortable: true,
    },
    {
      name: 'Quantity',
      selector: row => row.quantity,
      sortable: true,
    },
    {
      name: 'Freight',
      selector: row => "$ " + row.freight,
      sortable: true,
    },
    {
      name: 'Action',
      width: '110px',
      center: true,
      selector: row =>
        <div>
          {
            currentUserRolePermissionData?.includes("shipment:freight:update") ?
              <Button className="btn btn-sm btn-inox-green border-0 my-1" style={{ height: 30 }} title="Update" onClick={() => handleShowUpdateFreightModal(row)}>
                <i className="fa fa-edit"></i>
              </Button>
              :
              ""
          }

          {
            currentUserRolePermissionData?.includes("shipment:freight:delete") ?
              <Button className="btn btn-sm btn-danger my-1 mx-1" style={{ height: 30 }} title="Delete" onClick={() => handleDeleteFreightModal(row)}>
                <i className="fa fa-trash"></i>
              </Button>
              :
              ""
          }
        </div>,
    }
  ];


  const getFreightCharges = async (shipment) => {
    try {
      const response = await axios.get(process.env.REACT_APP_BACKEND_API_URL + '/master/shipmentfreight?shipment='+shipment);

      if (response) {
        setFreightChargeData(response.data)
      }
    } catch (err) {
      toast.error("Error in getting freight charge! Try again.");
    }
  }

  const handleCloseShipmentDetailsModal = () => {
    setShowShipmentDetailsModal(false)
    setShipmentDocumentData([])
    setShipmentHazardousClassInformationData([])
    setVesselTranshipmentLeg([])
    setFreightChargeData([])
  }

  const handleShowAddVesselRouteModal = () => {
    setShowAddVesselRouteModal(true)
  }

  const handleCloseAddVesselRouteModal = () => {
    setShowAddVesselRouteModal(false)
    setAgreementPickPort("")
    setAgreementNextPort("")
    setModeOfTransport("")
    setTranshipmentAgent("")
    setAgreementSlotOperator("")
    setAgreementPaymentAgent("")
    setVesselScheduleList([])
    setSlotRateList([])
    setSelectedVesselSchedule("")
    setSelectedSlotRate("")
  }

  const handleShowAddFreightModal = () => {
    setShowAddFreightModal(true)
  }

  const handleCloseAddFreightModal = () => {
    setShowAddFreightModal(false)
  }

  const handleShowUpdateFreightModal = (row) => {
    setShowUpdateFreightModal(true)
    setUpdateFreightId(row.id)
    setUpdateFreightType(row.type)
    setUpdateFreightQuantity(row.quantity)
    setUpdateFreightChargeAmount(row.freight)
  }

  const handleDeleteFreightModal = (row) => {
    setShowDeleteFreightModal(true)
    setDeleteFreightId(row.id)
  }

  const addFreightCharge = async (e) => {
    e.preventDefault();
    setAddFreightChargeLoader(true)

    const data = {
      "shipment": shipmentId,
      "type": addfreightform.current.freight_type.value,
      "quantity": addfreightform.current.freight_quantity.value,
      "freight": addfreightform.current.freight_charge.value,
      "created_by": JSON.stringify({"username": loggedInUser?.username, "name": loggedInUser?.name, "email": loggedInUser?.email, "mobile": loggedInUser?.mobile, "user_type": loggedInUser?.user_type})
    }

    try {
      const response = await axios.post(process.env.REACT_APP_BACKEND_API_URL + '/master/shipmentfreight/', data, { headers: { "Content-Type": "application/json" } });

      if (response.status == 201) {
        toast.success("Freight charge added successfully");
        getFreightCharges(shipmentId)
        addfreightform.current.freight_type.value = ""
        addfreightform.current.freight_quantity.value = 1
        addfreightform.current.freight_charge.value = 0
      }
    } catch (err) {
      toast.error("Error in adding freight charge! Try again.");
    }
    setAddFreightChargeLoader(false)
    setShowAddFreightModal(false)
  }

  const updateFreightCharge = async (e) => {
    e.preventDefault();
    setUpdateFreightChargeLoader(true)

    const id = updateFreightId

    const data = {
      "shipment": shipmentId,
      "type": updateFreightType,
      "quantity": updateFreightQuantity,
      "freight": updateFreightChargeAmount,
      "modified_by": JSON.stringify({"username": loggedInUser?.username, "name": loggedInUser?.name, "email": loggedInUser?.email, "mobile": loggedInUser?.mobile, "user_type": loggedInUser?.user_type})
    }

    try {
      const response = await axios.put(process.env.REACT_APP_BACKEND_API_URL + '/master/shipmentfreight/'+id+"/", data, { headers: { "Content-Type": "application/json" } });

      if (response.status == 200) {
        toast.success("Freight charge updated successfully");
        getFreightCharges(shipmentId)
      }
    } catch (err) {
      toast.error("Error in updating freight charge! Try again.");
    }
    setShowUpdateFreightModal(false)
    setUpdateFreightChargeLoader(false)
  }

  const deleteFreightCharge = async (e) => {
    e.preventDefault();
    setDeleteFreightChargeLoader(true)

    const id = deleteFreightId

    try {
      const response = await axios.delete(process.env.REACT_APP_BACKEND_API_URL + '/master/shipmentfreight/'+id+'/');

      if (response.status == 204) {
        toast.success("Freight charge deleted successfully");
        getFreightCharges(shipmentId)
      }
    } catch (err) {
      toast.error("Error in deleting freight charge! Try again.");
    }
    setDeleteFreightChargeLoader(false)
    setShowDeleteFreightModal(false)
  }


  // ---------------------------------- Notes ------------------------------------------
  const shipmentnotescolumns = [
    {
      name: 'Sr',
      selector: (row, index) => index + 1,
      sortable: true,
    },
    {
      name: 'Type',
      selector: row => row.type,
      sortable: true,
    },
    {
      name: 'Note',
      selector: row => row.notes,
      sortable: true,
    },
    {
      name: 'Agent',
      selector: row => row.agent_data?.name,
      sortable: true,
    },
    {
      name: 'Created By',
      selector: row => JSON.parse(row.created_by)?.name,
      sortable: true,
    },
    {
      name: 'Action',
      width: '110px',
      center: true,
      selector: row =>
        <div>
          {
            currentUserRolePermissionData?.includes("shipment:notes:update") ?
              <Button className="btn btn-sm btn-inox-green border-0 my-1" style={{ height: 30 }} title="Update" onClick={() => handleShowUpdateShipmentNotesModal(row)}>
                <i className="fa fa-edit"></i>
              </Button>
              :
              ""
          }

          {
            currentUserRolePermissionData?.includes("shipment:notes:delete") ?
              <Button className="btn btn-sm btn-danger my-1 mx-1" style={{ height: 30 }} title="Delete" onClick={() => handleDeleteShipmentNotesModal(row)}>
                <i className="fa fa-trash"></i>
              </Button>
              :
              ""
          }
        </div>,
    }
  ];

  const getShipmentNotes = async (notes_type) => {
    try {
      if(notes_type){
        const response = await axios.get(process.env.REACT_APP_BACKEND_API_URL + '/master/shipmentnotes?shipment='+shipmentId+'&type='+notes_type);
        if (response) {
          setShipmentNotesData(response.data)
        }
      }
      else{
        const response = await axios.get(process.env.REACT_APP_BACKEND_API_URL + '/master/shipmentnotes?shipment='+shipmentId);
        if (response) {
          setShipmentNotesData(response.data)
        }
      }
    } catch (err) {
      toast.error("Error in getting notes! Try again.");
    }
  }

  const handleShowAddShipmentNotesModal = () => {
    setShowAddShipmentNotesModal(true)
  }

  const handleCloseAddShipmentNotesModal = () => {
    setShowAddShipmentNotesModal(false)
  }

  const handleShowUpdateShipmentNotesModal = (row) => {
    setShowUpdateShipmentNotesModal(true)
    setUpdateShipmentNotesId(row.id)
    setUpdateShipmentNotesType(row.type)
    setUpdateShipmentNote(row.notes)
  }

  const handleDeleteShipmentNotesModal = (row) => {
    setShowDeleteShipmentNotesModal(true)
    setDeleteShipmentNotesId(row.id)
  }

  const addShipmentNotes = async (e) => {
    e.preventDefault();
    setAddShipmentNotesLoader(true)

    const data = {
      "shipment": shipmentId,
      "type": addshipmentnotesform.current.shipment_notes_type.value,
      "notes": addshipmentnotesform.current.shipment_notes.value,
      "agent": bookingAgent?.id,
      "created_by": JSON.stringify({"username": loggedInUser?.username, "name": loggedInUser?.name, "email": loggedInUser?.email, "mobile": loggedInUser?.mobile, "user_type": loggedInUser?.user_type})
    }

    try {
      const response = await axios.post(process.env.REACT_APP_BACKEND_API_URL + '/master/shipmentnotes/', data, { headers: { "Content-Type": "application/json" } });

      if (response.status == 201) {
        toast.success("Notes added successfully");
        getShipmentNotes()
        addshipmentnotesform.current.shipment_notes_type.value = ""
        addshipmentnotesform.current.shipment_notes.value = ""
      }
    } catch (err) {
      toast.error("Error in adding notes! Try again.");
    }
    setAddShipmentNotesLoader(false)
    setShowAddShipmentNotesModal(false)
  }

  const updateShipmentNotes = async (e) => {
    e.preventDefault();
    setUpdateShipmentNotesLoader(true)

    const id = updateShipmentNotesId

    const data = {
      "shipment": shipmentId,
      "type": updateShipmentNotesType,
      "notes": updateShipmentNote,
      "modified_by": JSON.stringify({"username": loggedInUser?.username, "name": loggedInUser?.name, "email": loggedInUser?.email, "mobile": loggedInUser?.mobile, "user_type": loggedInUser?.user_type})
    }

    try {
      const response = await axios.put(process.env.REACT_APP_BACKEND_API_URL + '/master/shipmentnotes/'+id+"/", data, { headers: { "Content-Type": "application/json" } });

      if (response.status == 200) {
        toast.success("Note updated successfully");
        getShipmentNotes()
      }
    } catch (err) {
      toast.error("Error in updating note! Try again.");
    }
    setShowUpdateShipmentNotesModal(false)
    setUpdateShipmentNotesLoader(false)
  }

  const deleteShipmentNotes = async (e) => {
    e.preventDefault();
    setDeleteShipmentNotesLoader(true)

    const id = deleteShipmentNotesId

    try {
      const response = await axios.delete(process.env.REACT_APP_BACKEND_API_URL + '/master/shipmentnotes/'+id+'/');

      if (response.status == 204) {
        toast.success("Note deleted successfully");
        getShipmentNotes()
      }
    } catch (err) {
      toast.error("Error in deleting note! Try again.");
    }
    setDeleteShipmentNotesLoader(false)
    setShowDeleteShipmentNotesModal(false)
  }

  //  ---------------------------------------- Miscellaneous Charges -----------------------------------
  const generateId = () => Date.now() + Math.random();

  const [miscellaneousChargeRows, setMiscellaneousChargeRows] = useState([
    {
      id: generateId,
      product_data: { "product_name": "Miscellaneous" },
      product_name: "Miscellaneous",
      remarks: "",
      charge_data: "",
      charge_name: "",
      amount: 0.0,
      expense: 0.0,
      amount_type: "AMOUNT",
      charge_basis: "",
      currency_data: "",
      currency: "",
      quantity: 1,
      total: 0.0,
      requested: 0.0,
      approved: 0.0,
      paid_by: "",
      approved_by: ""
    },
  ]);

  const addMiscellaneousChargeRow = () => {
    setMiscellaneousChargeRows([
      ...miscellaneousChargeRows,
      {
        id: generateId,
        product_data: { "product_name": "Miscellaneous" },
        product_name: "Miscellaneous",
        charge_name: "",
        remarks: "",
        amount: 0.0,
        expense: 0.0,
        amount_type: "AMOUNT",
        charge_basis: "",
        currency_data: "",
        currency: "",
        quantity: 1,
        total: 0.0,
        requested: 0.0,
        approved: 0.0,
        paid_by: "",
        approved_by: ""
      },
    ]);
  };

  const removeMiscellaneousChargeRow = (row, index) => {
    if (index == 0 && miscellaneousChargeRows.length == 1) {
      setMiscellaneousChargeRows([{
        id: generateId,
        product_data: { "product_name": "Miscellaneous" },
        product_name: "Miscellaneous",
        charge_data: "",
        charge_name: "",
        remarks: "",
        amount: 0.0,
        expense: 0.0,
        amount_type: "AMOUNT",
        charge_basis: "",
        currency_data: null,
        currency: "",
        quantity: 1,
        total: 0.0,
        requested: 0.0,
        approved: 0.0,
        paid_by: "",
        approved_by: ""
      }])

      document.getElementById("miscellaneous_charge_name0").value = "";
      document.getElementById("miscellaneous_remarks0").value = "";
      document.getElementById("miscellaneous_charge_amount0").value = "";
      document.getElementById("miscellaneous_charge_quantity0").value = 1;
      document.getElementById("miscellaneous_charge_requested0").value = "";
      document.getElementById("miscellaneous_charge_approved0").value = "";
      document.getElementById("miscellaneous_charge_currency0").value = null;
      document.getElementById("miscellaneous_charge_paid_by0").value = "NA";
    }
    else {
      var updated_miscellaneous_charges = miscellaneousChargeRows.filter(charge => !(charge.charge_name == row.charge_name))
      setMiscellaneousChargeRows(updated_miscellaneous_charges);
    }
  };

  const handleMiscellaneousChargeChange = (index, id, field, value) => {
    if (field == 'amount') {
      miscellaneousChargeRows[index]['amount'] = parseFloat(value);
      setMiscellaneousChargeRows(miscellaneousChargeRows);
    }
    else if(field == 'charge_name'){
      miscellaneousChargeRows[index]["charge_name"] = value?.label
      miscellaneousChargeRows[index]["charge_data"] = { value: value?.value, label: value?.label, sac_code: value?.sac_code, remarks: value?.remarks, expense_liking: value?.expense_liking }
      miscellaneousChargeRows[index]["remarks"] = value?.remarks;
      setMiscellaneousChargeRows(miscellaneousChargeRows);
    }
    else if(field == 'currency'){
      miscellaneousChargeRows[index]["currency"] = value?.label
      miscellaneousChargeRows[index]["currency_data"] = { value: value?.value, label: value?.label, current_value: value?.current_value, symbol: value?.symbol }
      setMiscellaneousChargeRows(miscellaneousChargeRows);
    }
    else {
      miscellaneousChargeRows[index][field] = value;
      setMiscellaneousChargeRows(miscellaneousChargeRows);
    }
  };


  const bringtodraft = async (e) => {
    e.preventDefault();
    setShowBringToDraftLoader(true)

    const data = {
      id: shipmentId,
      status: "DRAFT",
      modified_by: JSON.stringify({"id": loggedInUser?.id, "username": loggedInUser?.username, "name": loggedInUser?.name, "email": loggedInUser?.email, "mobile": loggedInUser?.mobile, "user_type": loggedInUser?.user_type})
    }

    const response = await axios.put(process.env.REACT_APP_BACKEND_API_URL + '/master/shipment/updatebookingstatus/', data,
      {
        headers: { 'content-type': 'application/json' }
      }
    );

    if (response.status == 200) {
      toast.success("Booking is back to draft")
    }

    getShipment(currentPage, 10, exportOptionStatus)
    setShowBringToDraftLoader(false)
    setShowBringToDraftModal(false)
    setShowShipmentDetailsModal(false)
  }

  const cancelbooking = async (e) => {
    e.preventDefault();
    setShowCancelBookingLoader(false)

    const data = {
      id: shipmentId,
      status: "CANCELLED",
      modified_by: JSON.stringify({"id": loggedInUser?.id, "username": loggedInUser?.username, "name": loggedInUser?.name, "email": loggedInUser?.email, "mobile": loggedInUser?.mobile, "user_type": loggedInUser?.user_type})
    }

    const response = await axios.put(process.env.REACT_APP_BACKEND_API_URL + '/master/shipment/updatebookingstatus/', data,
      {
        headers: { 'content-type': 'application/json' }
      }
    );

    if (response.status == 200) {
      toast.success("Booking is cancelled successfully")
    }

    getShipment(currentPage, 10, exportOptionStatus)
    setShowCancelBookingLoader(false)
    setShowCancelBookingModal(false)
    setShowShipmentDetailsModal(false)
  }

  const releaseatfd = async (e) => {
    e.preventDefault();
    setShowReleaseAtFdLoader(true)

    const data = {
      id: shipmentId,
      status: "RELEASE_AT_FD",
      modified_by: JSON.stringify({"id": loggedInUser?.id, "username": loggedInUser?.username, "name": loggedInUser?.name, "email": loggedInUser?.email, "mobile": loggedInUser?.mobile, "user_type": loggedInUser?.user_type})
    }

    const response = await axios.put(process.env.REACT_APP_BACKEND_API_URL + '/master/shipment/updatebookingstatus/', data,
      {
        headers: { 'content-type': 'application/json' }
      }
    );

    if (response.status == 200) {
      toast.success("Containers released at FD successfully")
    }

    getShipment(currentPage, 10, exportOptionStatus)
    setShowReleaseAtFdLoader(false)
    setShowReleaseAtFdModal(false)
    setShowShipmentDetailsModal(false)
  }

  const closeexport = async (e) => {
    e.preventDefault();
    setShowCloseExportLoader(true)

    const data = {
      id: shipmentId,
      status: "CLOSED",
      modified_by: JSON.stringify({"id": loggedInUser?.id, "username": loggedInUser?.username, "name": loggedInUser?.name, "email": loggedInUser?.email, "mobile": loggedInUser?.mobile, "user_type": loggedInUser?.user_type})
    }

    const response = await axios.put(process.env.REACT_APP_BACKEND_API_URL + '/master/shipment/updatebookingstatus/', data,
      {
        headers: { 'content-type': 'application/json' }
      }
    );

    if (response.status == 200) {
      toast.success("Export closed successfully")
    }

    getShipment(1, 10, exportOptionStatus)
    setShowCloseExportLoader(false)
    setShowCloseExportModal(false)
    setShowShipmentDetailsModal(false)
  }


  // ------------------------------------ Vessel Route -------------------------------------------
  const getPortByOrder = (timeline, pickPortName, nextPortName, checkPort) => {
    if(checkPort == "PICKUP"){
      const pickPorts = timeline.filter(p => p.name === pickPortName);
      const nextPorts = timeline.filter(p => p.name === nextPortName);

      // If either not found
      if (!pickPorts.length || !nextPorts.length) return null;

      // If only one occurrence
      if (pickPorts.length === 1 && nextPorts.length === 1) {
        return pickPorts[0]
      }

      // Multiple occurrences → apply index logic
      for (let pick of pickPorts) {
        const validNext = nextPorts.find(next => pick.index < next.index);
        if (validNext) {
          return pick
        }
      }
    }
    else if(checkPort == "NEXT"){
      const pickPorts = timeline.filter(p => p.name === pickPortName);
      const nextPorts = timeline.filter(p => p.name === nextPortName);

      // If either not found
      if (!pickPorts.length || !nextPorts.length) return null;

      // If only one occurrence
      if (pickPorts.length === 1 && nextPorts.length === 1) {
        return nextPorts[0]
      }

      // Multiple occurrences → apply index logic
      for (let pick of pickPorts) {
        const validNext = nextPorts.find(next => pick.index < next.index);
        if (validNext) {
          return validNext
        }
      }
    }

    return null;
  };

  const schedule_columns = [
    {
      name: 'Selected',
      selector: row => 
        selectedVesselSchedule == row.id? 
          <i className="fa fa-check-circle fa-2x text-success px-2"></i>
          :
          <i className="fa fa-times-circle fa-2x text-danger px-2"></i>
        ,
      width: '100px',
      sortable: true,
    },
    {
      name: 'Vessel',
      selector: row => row.vessel_data?.name,
      width: '250px',
      sortable: true,
    },
    {
      name: 'Voyage',
      selector: row => row.voyage,
      width: '100px',
      sortable: true,
    },
    {
      name: "Service",
      selector: row => <>
        {Object.values(row.service_data.sequence).map((port, i) => (
          <span>{i!=0?" → ":""}<b>{port.name}</b></span>
        ))}
      </>,
      wrap: true,
      width: '430px',
      sortable: true,
    },
    {
      name: 'Pickup Port',
      selector: row => agreementPickPort?.label,
      width: '250px',
      sortable: true,
    },
    {
      name: 'Pickup Terminal',
      selector: row => getPortByOrder(row.schedule_timeline, agreementPickPort?.label, agreementNextPort?.label, "PICKUP")?.terminal_name,
      width: '150px',
      sortable: true,
    },
    {
      name: 'Timings',
      selector: row => <>
        <span>
          <b>ETA:</b> 
          {getPortByOrder(row.schedule_timeline, agreementPickPort?.label, agreementNextPort?.label, "PICKUP")?.eta ?
            format(parseISO(getPortByOrder(row.schedule_timeline, agreementPickPort?.label, agreementNextPort?.label, "PICKUP")?.eta), "dd/MM/yyyy, hh:mm a") ?? ""
          :
            ""
          }
        </span><br></br>

        <span>
          <b>ETD:</b> 
          {getPortByOrder(row.schedule_timeline, agreementPickPort?.label, agreementNextPort?.label, "PICKUP")?.etd ?
            format(parseISO(getPortByOrder(row.schedule_timeline, agreementPickPort?.label, agreementNextPort?.label, "PICKUP")?.etd), "dd/MM/yyyy, hh:mm a") ?? ""
          :
            ""
          }  
          </span>
      </>,
      width: '200px',
      sortable: true,
    },
    {
      name: 'Next Port',
      selector: row => agreementNextPort?.label,
      width: '250px',
      sortable: true,
    },
    {
      name: 'Next Port Terminal',
      selector: row => getPortByOrder(row.schedule_timeline, agreementPickPort?.label, agreementNextPort?.label, "NEXT")?.terminal_name,
      width: '150px',
      sortable: true,
    },
    {
      name: 'Timings',
      selector: row => <>
        <span>
          <b>ETA:</b> 
          {getPortByOrder(row.schedule_timeline, agreementPickPort?.label, agreementNextPort?.label, "NEXT")?.eta ?
            format(parseISO(getPortByOrder(row.schedule_timeline, agreementPickPort?.label, agreementNextPort?.label, "NEXT")?.eta), "dd/MM/yyyy, hh:mm a") ?? ""
          :
            ""
          }
        </span><br></br>
        
        <span>
          <b>ETD:</b> 
          {getPortByOrder(row.schedule_timeline, agreementPickPort?.label, agreementNextPort?.label, "NEXT")?.etd ?
            format(parseISO(getPortByOrder(row.schedule_timeline, agreementPickPort?.label, agreementNextPort?.label, "NEXT")?.etd), "dd/MM/yyyy, hh:mm a") ?? ""
          :
            ""
          }
        </span>
      </>,
      width: '200px',
      sortable: true,
    },
    {
      name: "Action",
      center: true,
      width: '110px',
      selector: row => 
        <Button className={`btn btn-sm ${selectedVesselSchedule == row.id?"btn-success":"btn-inox-green"} border-0`} title="View Slot Rates" 
        onClick={() => 
          agreementSlotOperator && agreementPaymentAgent?
            searchSlotRate(row, agreementPickPort?.value, agreementNextPort?.value, row.service, agreementSlotOperator, agreementPaymentAgent)
          :
            toast.warning("Slot operator and payment agent are required")
          }>
          <i className={`fa ${selectedVesselSchedule == row.id?"fa-check":"fa-eye"} border-0`}></i>
        </Button>
    }
  ]

  const searchVesselRoute = async (pick_port, next_port, mode_of_transport) => {
    try {
      setVesselRoutePending(true)
      const schedule_response = await axios.get(process.env.REACT_APP_BACKEND_API_URL + '/master/vesselschedule/searchvesselschedule?pick_port='+pick_port+'&next_port='+next_port+'&vessel__type='+mode_of_transport);

      if (schedule_response) {
        setVesselScheduleList(schedule_response.data)
      }
      setVesselRoutePending(false)
    } catch (err) {
      toast.error("Error in fetching vessel schedule data! Try again.");
    }
  }

  const searchSlotRate = async (schedule, from_port, to_port, service, slot_oprator, payment_agent) => {
    try {
      setSelectedVesselSchedule(schedule?.id)

      console.log("schedule ***************************", schedule)
      console.log("from_port ***************************", from_port)
      console.log("to_port ***************************", to_port)
      console.log("service ***************************", service)
      console.log("slot_oprator ***************************", slot_oprator)
      console.log("payment_agent ***************************", payment_agent)

      const target_leg = parseInt(routeLeg) - 1
      const updated_leg = {
        "eta": getPortByOrder(schedule.schedule_timeline, agreementPickPort?.label, agreementNextPort?.label, "PICKUP")?.eta ?? null,
        "etd": getPortByOrder(schedule.schedule_timeline, agreementPickPort?.label, agreementNextPort?.label, "PICKUP")?.etd ?? null,
        "from": getPortByOrder(schedule.schedule_timeline, agreementPickPort?.label, agreementNextPort?.label, "PICKUP")?.name ?? "",
        "from_port": agreementPickPort?.label,
        "schedule": {
                    "id": schedule?.id, 
                    "service": schedule?.service_data?.name, 
                    "vessel": schedule?.vessel_data?.name, 
                    "voyage": schedule?.voyage
                  },
        "schedule_id": schedule?.id,
        "slot": 0,
        "to": getPortByOrder(schedule.schedule_timeline, agreementPickPort?.label, agreementNextPort?.label, "NEXT")?.name ?? "",
        "to_port": agreementNextPort?.label,
        "type": "TSP",
        "status": "UPDATED"
      }

      console.log("UPDATED setVesselTranshipmentLeg ***************************", vesselTranshipmentLeg)

      if (vesselTranshipmentLeg && Array.isArray(vesselTranshipmentLeg)) {
        const updated = [...vesselTranshipmentLeg];
        updated[target_leg] = updated_leg;
        setVesselTranshipmentLeg(updated);
      } else {
        setVesselTranshipmentLeg([updated_leg]);
      }

      const slot_agreement_response = await axios.get(process.env.REACT_APP_BACKEND_API_URL + '/master/slotagreement?from_port='+from_port+'&to_port='+to_port+'&service='+service+'&operator='+slot_oprator+'&agent='+payment_agent);

      if (slot_agreement_response) {
        const agreement_id = slot_agreement_response.data?.[0]?.id
        const slot_rate_response = await axios.get(process.env.REACT_APP_BACKEND_API_URL + '/master/slotrate?slot_agreement='+agreement_id+'&container_type__product_name='+containerType+'&cargo_type='+cargoType);
        setSlotRateList(slot_rate_response.data)
      }
    } catch (err) {
      toast.error("Error in fetching slot rate data! Try again.");
    }
  }

  const slot_rate_columns = [
    {
      name: 'Container Type',
      selector: row => row.container_type_data?.product_name,
      sortable: true,
    },
    {
      name: 'Cargo Type',
      width: '190px',
      selector: row => row.cargo_type,
      sortable: true,
    },
    {
      name: 'Rate',
      selector: row => row.currency_data?.symbol + " " + row.rate,
      sortable: true,
    },
    {
      name: 'Action',
      center: true,
      selector: row => 
        <Button className={`btn btn-sm ${selectedSlotRate==row.id?"btn-success":"btn-inox-green"} border-0`} title="Update" onClick={() => handleSelectSlotRate(row)}>
          <i className="fa fa-check"></i>
        </Button>
    }
  ];

  const handleSelectSlotRate = (data) => {
    setSelectedSlotRate(data?.id)
    const target_leg = parseInt(routeLeg) - 1
    vesselTranshipmentLeg[target_leg]['slot'] = data?.rate
    setVesselTranshipmentLeg(vesselTranshipmentLeg)
  }

  const handleVesselRoutePlanning = async (leg, schedule_id, pick_port_id, pick_port_name, next_port_id, next_port_name, mode_of_transport) => {
    try {
      setRouteLeg(leg)
      setSelectedVesselSchedule(schedule_id)
      setVesselRoutePending(true)
      setShowAddVesselRouteModal(true)
      setAgreementPickPort({value: pick_port_id, label: pick_port_name})
      setAgreementNextPort({value: next_port_id, label: next_port_name})
      setModeOfTransport(mode_of_transport)
      const schedule_response = await axios.get(process.env.REACT_APP_BACKEND_API_URL + '/master/vesselschedule/searchvesselschedule?pick_port='+pick_port_id+'&next_port='+next_port_id+'&vessel__type='+mode_of_transport);

      if (schedule_response) {
        setVesselScheduleList(schedule_response.data)
      }
      setVesselRoutePending(false)
    } catch (err) {
      toast.error("Error in fetching vessel schedule data! Try again.");
    }
  }


  function handleDataFromTopNavBar(permissiondata) {
    setDataFromTopNavBar(permissiondata);
  }

  return (
    <div className="page-content-bg">
      <ToastContainer></ToastContainer>
      <TopNavbar sidebarCollapsed={menuDrawerShow} topNavbarStatic={true} sendDataToParent={handleDataFromTopNavBar} />
      <SideNavbar sidebarCollapsed={menuDrawerShow} activeMenu="Shipment" activeSubMenu="Exports" activeSubMenuLevel1="PlannedExports" permissionFromTopNavbar={dataFromTopNavBar} />

      <div className={menuDrawerShow ? "row main-content-collapsed text-left py-0" : "row main-content text-left py-0"} >
        <div className="col-12 page-header">
          <div className="row">
            <div className="col-2 py-1">
              <div class="d-flex flex-row bd-highlight mb-3">
                <Button className="btn btn-sm btn-inox-green border-0 mx-2" onClick={() => setMenuDrawerShow(!menuDrawerShow)}>
                {menuDrawerShow ?
                  <span><i className="fa fa-chevron-left mx-1"></i></span> :
                  <span><i className="fa fa-chevron-right mx-1"></i></span>
                }
              </Button>

              <select className="form-select form-select-sm" onChange={(e) => [getShipment(1, 10, e.target.value), setExportOptionStatus(e.target.value)]}>
                <option value="APPROVED" selected={exportOptionStatus==""|exportOptionStatus=="APPROVED"?true:false}>Planned Exports</option>
                <option value="SOB" selected={exportOptionStatus=="SOB"?true:false}>SOB Bookings</option>
                <option value="CLOSED" selected={exportOptionStatus=="CLOSED"?true:false}>Closed Bookings</option>
                <option value="CANCELLED" selected={exportOptionStatus=="CANCELLED"?true:false}>Cancelled Bookings</option>
              </select>
              </div>
            </div>

            <div className="col-10 py-1">
              <div class="dropdown">
                <button type="button" style={{ paddingTop: 7, paddingBottom: 8, float: 'right', marginRight: 20, width: 35 }} title="Language" class="btn btn-inox-green border-0 text-white" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                  <span class="d-flex align-items-center">
                    <span className="fa fa-bars"></span>
                  </span>
                </button>

                <div class="dropdown-menu custom-topnavbar-dropdown-menu dropdown-menu-end" style={{ maxHeight: 700, overflowY: "auto", overflowX: "hidden" }}>
                  <Button className={`btn btn-sm ${showDescriptionView?"btn-inox-red":"btn-inox-green"} border-0 px-2 text-center ml-5`} title="Detail View" onClick={() => [setShowDescriptionView(true), setShowGridView(false), setShowVesselView(false)]}>
                    <i className="fa fa-th-large fa-lg text-center"></i>
                  </Button>
                  <Button className={`btn btn-sm ${showGridView?"btn-inox-red":"btn-inox-green"} border-0 px-2 text-center mx-2`} title="List View" onClick={() => [setShowDescriptionView(false), setShowGridView(true), setShowVesselView(false)]}>
                    <i className="fa fa-list fa-lg text-center"></i>
                  </Button>
                  <Button className={`btn btn-sm ${showVesselView?"btn-inox-red":"btn-inox-green"} border-0 px-2 text-center`} title="Vessel View" onClick={() => [setShowDescriptionView(false), setShowGridView(false), setShowVesselView(true)]}>
                    <i className="fa fa-ship fa-lg text-center"></i>
                  </Button>
                  <hr className="mb-0"></hr>

                  {showDescriptionView?
                    columns.map(col => (
                      <span class="dropdown-item pointer pointer">
                        <span>
                          <input type="checkbox"
                            checked={visibleCols.some(c => c.name === col.name)}
                            onChange={() => toggleColumn(col.name)} /> {col.name}
                        </span>
                      </span>
                    ))
                  :
                    gridcolumns.map(col => (
                      <span class="dropdown-item pointer pointer">
                        <span>
                          <input type="checkbox"
                            checked={visibleGridCols.some(c => c.name === col.name)}
                            onChange={() => toggleGridColumn(col.name)} /> {col.name}
                        </span>
                      </span>
                    ))
                  }
                </div>
              </div>

              {!showFilterForm ?
                <Button className="btn btn-sm btn-inox-green border-0 px-2 float-right" title="Filter Data" style={{ paddingTop: 5, marginRight: 5 }} onClick={() => setShowFilterForm(!showFilterForm)}>
                  <i className="fa fa-filter fa-lg text-right"></i>
                </Button>
                :
                <form ref={filterform}>
                  <div className="row justify-content-end" >
                    <div className="col-2" style={{ paddingRight: 0 }}>
                      <input type="text" readonly className="form-control form-control-sm" name="booking_number" placeholder="Booking Number" />
                    </div>
                    <div className="col-2" style={{ paddingRight: 0 }}>
                      <select className="form-select form-select-sm" name="cargo_type">
                        <option value="">Select Type</option>
                        <option value="HAZARDOUS">HAZARDOUS</option>
                        <option value="NON_HAZARDOUS">NON HAZARDOUS</option>
                        <option value="EMPTY">EMPTY</option>
                      </select>
                    </div>
                    <div className="col-2" style={{ paddingRight: 0 }}>
                      <select className="form-select form-select-sm" name="booking_status">
                        <option value="">Select Status</option>
                        <option value="WAITING_APPROVAL">WAITING APPROVAL</option>
                        <option value="APPROVED">APPROVED</option>
                        <option value="NOT_APPROVED">NOT APPROVED</option>
                        <option value="REJECTED">REJECTED</option>
                        <option value="CANCELLED">CANCELLED</option>
                        <option value="SOB">SOB</option>
                        <option value="CLOSED">CLOSED</option>
                        <option value="DRAFT">DRAFT</option>
                      </select>
                    </div>
                    <div className="col-2" style={{ paddingRight: 0 }}>
                      <select className="form-select form-select-sm" name="payment_type">
                        <option value="">Select Payment</option>
                        <option value="COLLECT">Collect</option>
                        <option value="PREPAID">Prepaid</option>
                      </select>
                    </div>
                    <div className="col-2" style={{ paddingRight: 0 }}>
                      <select className="form-select form-select-sm" name="sales_person">
                        <option value="">Select Sales Person</option>
                        {salesUser && salesUser.map(user =>
                          <option value={user.id}>{user.name}</option>
                        )}
                      </select>
                    </div>
                    <div className="col-2" style={{ paddingRight: 0 }}>
                      <Button className="btn btn-sm btn-secondary mx-1 float-right mr-1 pb-1" style={{ width: 35 }} onClick={() => [setShowFilterForm(!showFilterForm), getShipment(currentPage, 10, exportOptionStatus)]}>
                        <i className="fa fa-times"></i>
                      </Button>

                      <Button className="btn btn-sm btn-inox-green border-0 float-right" style={{ paddingBottom: 6, width: 100 }} onClick={(e) => filterData(e, 1, 10)}>Search</Button>
                    </div>
                  </div>
                </form>
              }
            </div>
          </div>
        </div>

        <div className="col-12 text-left" style={{ marginTop: -5, paddingLeft: 20, paddingRight: 30 }}>
          {!showVesselView?
          <DataTable
            columns={showDescriptionView? visibleCols: visibleGridCols}
            data={data}
            progressPending={dataPending}
            progressComponent={<Spinner className="mx-5 text-inox-green table-spinner" as="span" animation="border" size="lg" role="status" aria-hidden="true" />}
            noDataComponent={<p className="text-center table-no-data">No Data Found</p>}
            highlightOnHover
            // fixedHeader
            customStyles={showDescriptionView? shipmentTableCustomStyles: userTableCustomStyles}
            dense
            pagination
            paginationServer
            paginationTotalRows={totalData}
            onChangeRowsPerPage={handlePerRowsChange}
            onChangePage={handlePageChange}
          />
          :
          <DataTable
            columns={vesselshipmentcolumns}
            data={vesselShipmentData}
            progressPending={dataPending}
            progressComponent={<Spinner className="mx-5 text-inox-green table-spinner" as="span" animation="border" size="lg" role="status" aria-hidden="true" />}
            noDataComponent={<p className="text-center table-no-data">No Data Found</p>}
            pagination
            paginationPerPage={10}
            paginationRowsPerPageOptions={[10, 25, 50, 100, 1000, 5000, 10000]}
            highlightOnHover
            fixedHeader
            customStyles={vesselShipmentConditionalRowStyles}
            dense
            expandableRows
            expandableRowsComponent={ExpandedVesselShipmentComponent}
          />
          }
        </div>
      </div>

      <Modal size="xl" show={showShipmentDetailsModal} onHide={() => handleCloseShipmentDetailsModal()} centered fullscreen>
        <Modal.Header closeButton>
          <Modal.Title>Booking Number: {bookingNumber} ({shipmentStatus})</Modal.Title>
        </Modal.Header>
        <Modal.Body className="pt-0">
          <div className="row">
            <div className="col-1">
              <div class="sidenav">
                <div className="float-left w-100">
                  <a onClick={() => [setActiveTab("Details")]} title="Details" className={activeTab == "Details" ? "sidenav-expanded-active pointer px-0 sidenavbar-text text-white" : "pointer px-0 sidenavbar-text text-white"}>
                    <span className="mx-3">Details</span>
                  </a>

                  <a onClick={() => [setActiveTab("Notes")]} title="Details" className={activeTab == "Notes" ? "sidenav-expanded-active pointer px-0 sidenavbar-text text-white" : "pointer px-0 sidenavbar-text text-white"}>
                    <span className="mx-3">Notes</span>
                  </a>

                  {shipmentStatus == "APPROVED"?
                  <a onClick={() => [setActiveTab("CRO")]} title="CRO" className={activeTab == "CRO" ? "sidenav-expanded-active pointer px-0 sidenavbar-text text-white" : "pointer px-0 sidenavbar-text text-white"}>
                    <span className="mx-3">CRO</span>
                  </a>
                  :
                  <a title="CRO" className="px-0 sidenavbar-text text-secondary" style={{ cursor: 'not-allowed'}}>
                    <span className="mx-3">CRO</span>
                  </a>
                  }

                  {shipmentStatus == "APPROVED"?
                  <a onClick={() => [setActiveTab("ExportBilling")]} title="Export Billing" className={activeTab == "ExportBilling" ? "sidenav-expanded-active pointer px-0 sidenavbar-text text-white" : "pointer px-0 sidenavbar-text text-white"}>
                    <span className="mx-3">Export Billing</span>
                  </a>
                  :
                  <a title="Export Billing" className="px-0 sidenavbar-text text-secondary" style={{ cursor: 'not-allowed'}}>
                    <span className="mx-3">Export Billing</span>
                  </a>
                  }

                  {shipmentStatus == "APPROVED"?
                  <a onClick={() => [setActiveTab("BL")]} title="BL" className={activeTab == "BL" ? "sidenav-expanded-active pointer px-0 sidenavbar-text text-white" : "pointer px-0 sidenavbar-text text-white"}>
                    <span className="mx-3">BL</span>
                  </a>
                  :
                  <a title="BL" className="px-0 sidenavbar-text text-secondary" style={{ cursor: 'not-allowed'}}>
                    <span className="mx-3">BL</span>
                  </a>
                  }

                  {shipmentStatus == "APPROVED"?
                  <a onClick={() => [setActiveTab("Containers")]} title="Containers" className={activeTab == "Containers" ? "sidenav-expanded-active pointer px-0 sidenavbar-text text-white" : "pointer px-0 sidenavbar-text text-white"}>
                    <span className="mx-3">Containers</span>
                  </a>
                  :
                  <a title="Containers" className="px-0 sidenavbar-text text-secondary" style={{ cursor: 'not-allowed'}}>
                    <span className="mx-3">Containers</span>
                  </a>
                  }

                  <a onClick={() => [setActiveTab("Activities")]} title="Activities" className={activeTab == "Activities" ? "sidenav-expanded-active pointer px-0 sidenavbar-text text-white" : "pointer px-0 sidenavbar-text text-white"}>
                    <span className="mx-3">Activities</span>
                  </a>

                  <a onClick={() => [setActiveTab("Notifications")]} title="Notifications" className={activeTab == "Notifications" ? "sidenav-expanded-active pointer px-0 sidenavbar-text text-white" : "pointer px-0 sidenavbar-text text-white"}>
                    <span className="mx-3">Notifications</span>
                  </a>

                  <a onClick={() => [setActiveTab("Tasks")]} title="Tasks" className={activeTab == "Tasks" ? "sidenav-expanded-active pointer px-0 sidenavbar-text text-white" : "pointer px-0 sidenavbar-text text-white"}>
                    <span className="mx-3">Tasks</span>
                  </a>

                  <a onClick={() => [setActiveTab("Expenses")]} title="Expenses" className={activeTab == "Expenses" ? "sidenav-expanded-active pointer px-0 sidenavbar-text text-white" : "pointer px-0 sidenavbar-text text-white"}>
                    <span className="mx-3">Expenses</span>
                  </a>

                  <a onClick={() => [setActiveTab("Documents")]} title="Documents" className={activeTab == "Documents" ? "sidenav-expanded-active pointer px-0 sidenavbar-text text-white" : "pointer px-0 sidenavbar-text text-white"}>
                    <span className="mx-3">Documents</span>
                  </a>

                  <a onClick={() => [setActiveTab("Uploads")]} title="Uploads" className={activeTab == "Uploads" ? "sidenav-expanded-active pointer px-0 sidenavbar-text text-white" : "pointer px-0 sidenavbar-text text-white"}>
                    <span className="mx-3">Uploads</span>
                  </a>

                  <a onClick={() => [setActiveTab("Chat")]} title="Chat" className={activeTab == "Chat" ? "sidenav-expanded-active pointer px-0 sidenavbar-text text-white" : "pointer px-0 sidenavbar-text text-white"}>
                    <span className="mx-3">Chat</span>
                  </a>
                </div>
              </div>
            </div>

            <div className="col-11">
              <div style={{ display: activeTab == "Details" ? "block" : "none" }}>
                <div className="row mt-2">
                  <div className="col-12">
                    <div class="dropdown">
                      <button type="button" style={{ paddingTop: 7, paddingBottom: 8, float: 'right' }} title="Language" class="btn btn-inox-green border-0 text-white" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        <span class="d-flex align-items-center">
                          <span className="fa fa-bars"></span>
                        </span>
                      </button>

                      <div class="dropdown-menu custom-topnavbar-dropdown-menu dropdown-menu-end">
                        <span className={`dropdown-item ${shipmentStatus == "SOB" ? "pointer" : "disabled"}`} onClick={() => setShowReleaseAtFdModal(true)}>
                          <i className="fa fa-check text-success"></i><span className="mx-2">Release at FD</span>
                        </span>

                        <span className={`dropdown-item ${!shipmentStatus == "DRAFT" ? "pointer" : "disabled"}`} onClick={() => setShowCloseExportModal(true)}>
                          <i className="fa fa-ban text-secondary"></i><span className="mx-2">Close Export</span>
                        </span>

                        <span className={`dropdown-item ${shipmentStatus == "CANCELLED" ? "disabled" : "pointer"}`} onClick={() => setShowCancelBookingModal(true)}>
                          <i className="fa fa-times text-danger"></i><span className="mx-2">Cancel Booking</span>
                        </span>

                        <span className={`dropdown-item ${shipmentStatus == "DRAFT" ? "disabled" : "pointer"}`} onClick={() => setShowBringToDraftModal(true)}>
                          <i className="fa fa-file text-info"></i><span className="mx-2">Bring to Draft</span>
                        </span>

                        <span class="dropdown-item pointer" onClick={() => setShowMiscellaneousChargesModal(true)}>
                          <i className="fa fa-money text-success"></i><span className="mx-2">Miscellaneous Charges</span>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>

                <form>
                  <fieldset class="border px-3 pb-3 rounded bg-light mt-4">
                    <legend class="w-auto pr-2 text-inox-green fw-semibold rounded px-2" style={{ marginTop: "-15px", background: "white", border: '1px solid #CFCFCF' }}>Route</legend>
                    <div className="row">
                      <div className="col-3">
                        <div class="form-group mb-2">
                          <label for="poa" class="col-12 col-form-label font-12px">POA</label>
                          <div class="col-12">
                            <select id="poa" name="poa" className="form-select form-select-sm" disabled>
                              <option value="" selected={poa?.id == "" ? true : false}>Select POA</option>
                              {portList.map(port => (
                                <option value={port.id} selected={port.id == poa.id ? true : false}>{port.name}</option>
                              ))}
                            </select>
                          </div>
                        </div>
                      </div>

                      <div className="col-3">
                        <div class="form-group mb-2">
                          <label for="pol" class="col-12 col-form-label font-12px">POL</label>
                          <div class="col-12">
                            <select id="pol" name="pol" className="form-select form-select-sm" disabled>
                              <option value="" selected={pol?.id == "" ? true : false}>Select POL</option>
                              {portList.map(port => (
                                <option value={port.id} selected={port.id == pol.id ? true : false}>{port.name}</option>
                              ))}
                            </select>
                          </div>
                        </div>
                      </div>

                      <div className="col-3">
                        <div class="form-group mb-2">
                          <label for="pod" class="col-12 col-form-label font-12px">POD</label>
                          <div class="col-12">
                            <select id="pod" name="pod" className="form-select form-select-sm" disabled>
                              <option value="" selected={pod?.id == "" ? true : false}>Select POD</option>
                              {portList.map(port => (
                                <option value={port.id} selected={port.id == pod.id ? true : false}>{port.name}</option>
                              ))}
                            </select>
                          </div>
                        </div>
                      </div>

                      <div className="col-3">
                        <div class="form-group mb-2">
                          <label for="fd" class="col-12 col-form-label font-12px">FD</label>
                          <div class="col-12">
                            <select id="fd" name="fd" className="form-select form-select-sm" disabled>
                              <option value="" selected={fd?.id == "" ? true : false}>Select FD</option>
                              {portList.map(port => (
                                <option value={port.id} selected={port.id == fd.id ? true : false}>{port.name}</option>
                              ))}
                            </select>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-3">
                        <div class="form-group mb-2">
                          <label for="shipment_type" class="col-12 col-form-label font-12px">Shipment Type</label>
                          <div class="col-12">
                            <select id="shipment_type" name="shipment_type" className="form-select form-select-sm" disabled>
                              <option value="DIRECT" selected={shipmentType == "DIRECT" ? true : false}>DIRECT</option>
                              <option value="THROUGH" selected={shipmentType == "THROUGH" ? true : false}>THROUGH</option>
                              <option value="VIA" selected={shipmentType == "VIA" ? true : false}>VIA</option>
                            </select>
                          </div>
                        </div>
                      </div>

                      {shipmentType == "VIA" ?
                        <div className="col-9">
                          <div class="form-group mb-2">
                            <label for="transhipment_vessel_route" class="col-12 col-form-label font-12px">Vessel Transhipment Route</label>
                            <div class="col-12">
                              {transhipmentVesselRoute}
                            </div>
                          </div>
                        </div>
                        : ""}
                    </div>
                  </fieldset>

                  <fieldset class="border px-3 pb-3 rounded bg-light mt-4">
                    <legend class="w-auto pr-2 text-inox-green fw-semibold rounded px-2" style={{ marginTop: "-15px", background: "white", border: '1px solid #CFCFCF' }}>Cargo and Containers</legend>
                    {bookingLineItem.map(item => (
                      <div className="row">
                        <div className="col-3">
                          <div class="form-group mb-2">
                            <label class="col-12 col-form-label font-12px">Container</label>
                            <div class="col-12">
                              <select className="form-select form-select-sm" disabled>
                                <option value="" selected={item?.container_type == "" ? true : false}>Select Container</option>
                                {containerList.map(container => (
                                  <option value={container.product_name} selected={container.product_name == item?.container_type ? true : false}>{container.product_name}</option>
                                ))}
                              </select>
                            </div>
                          </div>
                        </div>

                        <div className="col-3">
                          <div class="form-group mb-2">
                            <label class="col-12 col-form-label font-12px">Quantity</label>
                            <div class="col-12">
                              <input type="number" className="form-control form-control-sm" min={1} value={item.container_quantity}  disabled/>
                            </div>
                          </div>
                        </div>

                        <div className="col-3">
                          <div class="form-group mb-2">
                            <label class="col-12 col-form-label font-12px">Cargo Type</label>
                            <div class="col-12">
                              <select className="form-select form-select-sm" disabled>
                                <option value="" selected={item?.cargo_type == "" ? true : false}>Select Cargo type</option>
                                <option value="NON_HAZARDOUS" selected={item?.cargo_type == "NON_HAZARDOUS" ? true : false}>NON HAZARDOUS</option>
                                <option value="HAZARDOUS" selected={item?.cargo_type == "HAZARDOUS" ? true : false}>HAZARDOUS</option>

                                <option value="EMPTY" selected={item?.cargo_type == "EMPTY" ? true : false}>EMPTY</option>
                              </select>
                            </div>
                          </div>
                        </div>

                        <div className="col-3">
                          <div class="form-group mb-2">
                            <label class="col-12 col-form-label font-12px">Cargo</label>
                            <div class="col-12">
                              <select className="form-select form-select-sm" disabled>
                                <option value="" selected={item?.commodity == "" ? true : false}>Select Cargo</option>
                                {cargoList.map(cargo => (
                                  <option value={cargo.name} selected={cargo.name == item?.commodity ? true : false}>{cargo.name}</option>
                                ))}
                              </select>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}

                    <div className="row">
                      <div className="col-3">
                        <div class="form-group mb-2">
                          <label for="weight" class="col-12 col-form-label font-12px">Weight (MT)</label>
                          <div class="col-12">
                            <input type="number" id="weight" name="weight" className="form-control form-control-sm" value={weight}  disabled/>
                          </div>
                        </div>
                      </div>
                    </div>
                  </fieldset>

                  <fieldset class="border px-3 pb-3 rounded bg-light mt-4">
                    <legend class="w-auto pr-2 text-inox-green fw-semibold rounded px-2" style={{ marginTop: "-15px", background: "white", border: '1px solid #CFCFCF' }}>Stakeholder</legend>
                    <div className="row">
                      <div className="col-3">
                        <div class="form-group mb-2">
                          <label for="booking_agent" class="col-12 col-form-label font-12px">Booking Agent</label>
                          <div class="col-12">
                            <select id="booking_agent" name="booking_agent" className="form-select form-select-sm">
                              <option value="" selected={bookingAgent?.id == "" ? true : false}>Select Booking Agent</option>
                              {agentList.map(agent => (
                                <option value={agent?.id} selected={agent.id == bookingAgent?.id ? true : false}>{agent?.name}</option>
                              ))}
                            </select>
                          </div>
                        </div>
                      </div>

                      <div className="col-3">
                        <div class="form-group mb-2">
                          <label for="principal" class="col-12 col-form-label font-12px">Principal</label>
                          <div class="col-12">
                            <select id="principal" name="principal" className="form-select form-select-sm">
                              <option value="" selected={principal?.id == "" ? true : false}>Select Principal</option>
                              {principalList.map(principal_user => (
                                <option value={principal_user?.id} selected={principal_user.id == principal?.id ? true : false}>{principal_user?.name}</option>
                              ))}
                            </select>
                          </div>
                        </div>
                      </div>

                      <div className="col-3">
                        <div class="form-group mb-2">
                          <label for="booking_party" class="col-12 col-form-label font-12px">Booking Party</label>
                          <div class="col-12">
                            <select id="booking_party" name="booking_party" className="form-select form-select-sm">
                              <option value="" selected={bookingParty?.id == "" ? true : false}>Select Booking Party</option>
                              {userList.map(user => (
                                <option value={user?.id} selected={user.id == bookingParty?.id ? true : false}>{user?.name}</option>
                              ))}
                            </select>
                          </div>
                        </div>
                      </div>

                      <div className="col-3">
                        <div class="form-group mb-2">
                          <label for="delivery_agent" class="col-12 col-form-label font-12px">Delivery Agent</label>
                          <div class="col-12">
                            <select id="delivery_agent" name="delivery_agent" className="form-select form-select-sm">
                              <option value="" selected={deliveryAgent?.id == "" ? true : false}>Select Delivery Agent</option>
                              {agentList.map(agent => (
                                <option value={agent?.id} selected={agent.id == deliveryAgent?.id ? true : false}>{agent?.name}</option>
                              ))}
                            </select>
                          </div>
                        </div>
                      </div>

                      <div className="col-3">
                        <div class="form-group mb-2">
                          <label for="shipper" class="col-12 col-form-label font-12px">Slot Operator</label>
                          <div class="col-12">
                            <input type="text" id="shipper" name="shipper" class="form-control form-control-sm" value={slotOperator?.name}></input>
                          </div>
                        </div>
                      </div>

                      <div className="col-3">
                        <div class="form-group mb-2">
                          <label for="shipper" class="col-12 col-form-label font-12px">Shipper</label>
                          <div class="col-12">
                            <input type="text" id="shipper" name="shipper" class="form-control form-control-sm" value={shipper}></input>
                          </div>
                        </div>
                      </div>

                      <div className="col-3">
                        <div class="form-group mb-2">
                          <label for="on_account" class="col-12 col-form-label font-12px">On Account</label>
                          <div class="col-12">
                            <select id="on_account" name="on_account" className="form-select form-select-sm">
                              <option value="" selected={onAccount == "" ? true : false}>Select On Account</option>
                              <option value="SHIPPER" selected={onAccount == "SHIPPER" ? true : false}>SHIPPER</option>
                              <option value="CONSIGNEE" selected={onAccount == "CONSIGNEE" ? true : false}>CONSIGNEE</option>
                            </select>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-3">
                        <div class="form-group mb-2">
                          <label for="export_person" class="col-12 col-form-label font-12px">Export Person</label>
                          <div class="col-12">
                            <select id="export_person" name="export_person" className="form-select form-select-sm" onChange={(e) => setExportPerson(e.target.value)}>
                              <option value="" selected={exportPerson?.id == "" ? true : false}>Select Export Person</option>
                              {agentList.map(agent => (
                                <option value={agent?.id} selected={agent.id == exportPerson?.id ? true : false}>{agent?.name}</option>
                              ))}
                            </select>
                          </div>
                        </div>
                      </div>

                      <div className="col-3">
                        <div class="form-group mb-2">
                          <label for="import_person" class="col-12 col-form-label font-12px">Import Person</label>
                          <div class="col-12">
                            <select id="import_person" name="import_person" className="form-select form-select-sm" onChange={(e) => setImportPerson(e.target.value)}>
                              <option value="" selected={importPerson?.id == "" ? true : false}>Select Import Person</option>
                              {agentList.map(agent => (
                                <option value={agent?.id} selected={agent.id == importPerson?.id ? true : false}>{agent?.name}</option>
                              ))}
                            </select>
                          </div>
                        </div>
                      </div>

                      <div className="col-3">
                        <div class="form-group mb-2">
                          <label for="transhipment_person" class="col-12 col-form-label font-12px">Transhipment Person</label>
                          <div class="col-12">
                            <select id="transhipment_person" name="transhipment_person" className="form-select form-select-sm" onChange={(e) => setTranshipmentPerson(e.target.value)}>
                              <option value="" selected={transhipmentPerson?.id == "" ? true : false}>Select Transhipment Person</option>
                              {agentList.map(agent => (
                                <option value={agent?.id} selected={agent.id == transhipmentPerson?.id ? true : false}>{agent?.name}</option>
                              ))}
                            </select>
                          </div>
                        </div>
                      </div>
                    </div>
                  </fieldset>

                  <fieldset class="border px-3 pb-3 rounded bg-light mt-4">
                    <legend class="w-auto pr-2 text-inox-green fw-semibold rounded px-2" style={{ marginTop: "-15px", background: "white", border: '1px solid #CFCFCF' }}>Logistic Partners</legend>
                    <div className="row">
                      <div className="col-3">
                        <div class="form-group mb-2">
                          <label for="sales_person" class="col-12 col-form-label font-12px">Sales Person</label>
                          <div class="col-12">
                            <select id="sales_person" name="sales_person" className="form-select form-select-sm">
                              <option value="" selected={salesPerson?.id == "" ? true : false}>Select Sales Person</option>
                              {salesUser.map(sales_user => (
                                <option value={sales_user?.id} selected={sales_user.id == salesPerson?.id ? true : false}>{sales_user?.name}</option>
                              ))}
                            </select>
                          </div>
                        </div>
                      </div>

                      <div className="col-3">
                        <div class="form-group mb-2">
                          <label for="rate_approved_by" class="col-12 col-form-label font-12px">Rate Approved By</label>
                          <div class="col-12">
                            <select id="rate_approved_by" name="rate_approved_by" className="form-select form-select-sm">
                              <option value="" selected={rateApprovedBy?.id == "" ? true : false}>Select User</option>
                              {userList.map(user => (
                                <option value={user.id} selected={user.id == rateApprovedBy?.id ? true : false}>{user.name}</option>
                              ))}
                            </select>
                          </div>
                        </div>
                      </div>

                      <div className="col-3">
                        <div class="form-group mb-2">
                          <label for="space_confirmed_by" class="col-12 col-form-label font-12px">Space Confirmed By</label>
                          <div class="col-12">
                            <select id="space_confirmed_by" name="space_confirmed_by" className="form-select form-select-sm">
                              <option value="" selected={spaceConfirmedBy?.id == "" ? true : false}>Select User</option>
                              {userList.map(user => (
                                <option value={user.id} selected={user.id == spaceConfirmedBy?.id ? true : false}>{user.name}</option>
                              ))}
                            </select>
                          </div>
                        </div>
                      </div>
                    </div>
                  </fieldset>

                  <fieldset class="border px-3 pb-3 rounded bg-light mt-4">
                    <legend class="w-auto pr-2 text-inox-green fw-semibold rounded px-2" style={{ marginTop: "-15px", background: "white", border: '1px solid #CFCFCF' }}>Bill of Lading</legend>
                    <div className="row">
                      <div className="col-9">
                        <div className="row">
                          <div className="col-3">
                            <div class="form-group mb-2">
                              <label for="bl_type" class="col-12 col-form-label font-12px">BL Type</label>
                              <div class="col-12">
                                <select id="bl_type" name="bl_type" className="form-select form-select-sm">
                                  <option value="" selected={blType == "" ? true : false}>Select BL Type</option>
                                  <option value="ORIGINAL" selected={blType == "ORIGINAL" ? true : false}>ORIGINAL</option>
                                  <option value="SEA_WAY" selected={blType == "SEA_WAY" ? true : false}>SEA WAY</option>
                                  <option value="SURRENDER" selected={blType == "SURRENDER" ? true : false}>SURRENDER</option>
                                </select>
                              </div>
                            </div>
                          </div>

                          <div className="col-3">
                            <div class="form-group mb-2">
                              <label for="bl_sub_type" class="col-12 col-form-label font-12px">BL Sub Type</label>
                              <div class="col-12">
                                <select id="bl_sub_type" name="bl_sub_type" className="form-select form-select-sm">
                                  <option value="NA" selected={blSubType == "NA" ? true : false}>NA</option>
                                  <option value="PART_BL" selected={blSubType == "PART_BL" ? true : false}>PART BL</option>
                                  <option value="SWITCH_BL" selected={blSubType == "SWITCH_BL" ? true : false}>SWITCH BL</option>
                                </select>
                              </div>
                            </div>
                          </div>

                          <div className="col-3">
                            <div class="form-group mb-2">
                              <label for="payment" class="col-12 col-form-label font-12px">Payment Type</label>
                              <div class="col-12">
                                <select id="bl_sub_type" name="bl_sub_type" className="form-select form-select-sm">
                                  <option value="COLLECT" selected={paymentStaus == "COLLECT" ? true : false}>COLLECT</option>
                                  <option value="PREPAID" selected={paymentStaus == "PREPAID" ? true : false}>PREPAID</option>
                                </select>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </fieldset>

                  <fieldset class="border px-3 pb-3 rounded bg-light mt-4">
                    <legend class="w-auto pr-2 text-inox-green fw-semibold rounded px-2" style={{ marginTop: "-15px", background: "white", border: '1px solid #CFCFCF' }}>Inland Haulage Charge (IHC)</legend>
                    <div className="row">
                      <div className="col-9">
                        <div className="row">
                          <div className="col-3">
                            <div class="form-group mb-2">
                              <label for="export_ihc" class="col-12 col-form-label font-12px">Export IHC</label>
                              <div class="col-12">
                                <select id="export_ihc" name="export_ihc" className="form-select form-select-sm">
                                  <option value="NA" selected={pol.type == "SEAPORT" ? true : false}>NA</option>
                                  <option value="APPLIED" selected={pol.type == "DRYPORT" ? true : false}>APPLIED</option>
                                </select>
                              </div>
                            </div>
                          </div>

                          <div className="col-3">
                            <div class="form-group mb-2">
                              <label for="import_ihc" class="col-12 col-form-label font-12px">Import IHC</label>
                              <div class="col-12">
                                <select id="import_ihc" name="import_ihc" className="form-select form-select-sm">
                                  <option value="NA" selected={fd.type == "SEAPORT" ? true : false}>NA</option>
                                  <option value="APPLIED" selected={fd.type == "DRYPORT" ? true : false}>APPLIED</option>
                                </select>
                              </div>
                            </div>
                          </div>

                          <div className="col-3">
                            <div class="form-group mb-2">
                              <label for="export_ihc_payment_type" class="col-12 col-form-label font-12px">Export IHC Payment Type</label>
                              <div class="col-12">
                                <select id="export_ihc_payment_type" name="export_ihc_payment_type" className="form-select form-select-sm">
                                  <option value="NA" selected={ihcExportPaymentType == "NA" ? true : false}>NA</option>
                                  <option value="COLLECT" selected={ihcExportPaymentType == "COLLECT" ? true : false}>COLLECT</option>
                                  <option value="PREPAID" selected={ihcExportPaymentType == "PREPAID" ? true : false}>PREPAID</option>
                                </select>
                              </div>
                            </div>
                          </div>

                          <div className="col-3">
                            <div class="form-group mb-2">
                              <label for="import_ihc_payment_type" class="col-12 col-form-label font-12px">Import IHC Payment Type</label>
                              <div class="col-12">
                                <select id="import_ihc_payment_type" name="import_ihc_payment_type" className="form-select form-select-sm">
                                  <option value="NA" selected={ihcImportPaymentType == "NA" ? true : false}>NA</option>
                                  <option value="COLLECT" selected={ihcImportPaymentType == "COLLECT" ? true : false}>COLLECT</option>
                                  <option value="PREPAID" selected={ihcImportPaymentType == "PREPAID" ? true : false}>PREPAID</option>
                                </select>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </fieldset>

                  <fieldset class="border px-3 pb-3 rounded bg-light mt-4">
                    <legend class="w-auto pr-2 text-inox-green fw-semibold rounded px-2" style={{ marginTop: "-15px", background: "white", border: '1px solid #CFCFCF' }}>Free Days</legend>
                    <div className="row">
                      <div className="col-9">
                        <div className="row">
                          <div className="col-3">
                            <div class="form-group mb-2">
                              <label for="poa_detention_free_days" class="col-12 col-form-label font-12px">POA Detention Free Days</label>
                              <div class="col-12">
                                <input type="number" id="poa_detention_free_days" name="poa_detention_free_days" className="form-control form-control-sm" min={1} value={poaDetentionFreeDays} />
                              </div>
                            </div>
                          </div>

                          <div className="col-3">
                            <div class="form-group mb-2">
                              <label for="pod_detention_free_days" class="col-12 col-form-label font-12px">POD Detention Free Days</label>
                              <div class="col-12">
                                <input type="number" id="pod_detention_free_days" name="pod_detention_free_days" className="form-control form-control-sm" min={1} value={podDetentionFreeDays} />
                              </div>
                            </div>
                          </div>

                          <div className="col-3">
                            <div class="form-group mb-2">
                              <label for="poa_terminal_storage_free_days" class="col-12 col-form-label font-12px">POA Terminal Storage Free Days</label>
                              <div class="col-12">
                                <input type="number" id="poa_terminal_storage_free_days" name="poa_terminal_storage_free_days" className="form-control form-control-sm" min={1} value={poaTerminalStorageFreeDays} />
                              </div>
                            </div>
                          </div>

                          <div className="col-3">
                            <div class="form-group mb-2">
                              <label for="pod_terminal_storage_free_days" class="col-12 col-form-label font-12px">POD Terminal Storage Free Days</label>
                              <div class="col-12">
                                <input type="number" id="pod_terminal_storage_free_days" name="pod_terminal_storage_free_days" className="form-control form-control-sm" min={1} value={podTerminalStorageFreeDays} />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="col-3">
                        <div className="row">
                          <div class="form-group mb-2">
                            <label for="pod_terminal_storage_free_days" class="col-12 col-form-label font-12px">Transhipment Storage Free Days</label>
                            {transhipmentStorageFreeDays && transhipmentStorageFreeDays.map(transhipment_storage => (
                              <p className="mb-0">
                                {transhipment_storage?.['terminal_data']?.['port_data']?.['name']} ({transhipment_storage?.['terminal_data']?.['name']}): {transhipment_storage?.['param_value']}
                              </p>
                            ))}
                          </div>
                        </div>
                      </div>
                    </div>
                  </fieldset>

                  <fieldset class="border px-3 pb-3 rounded bg-light mt-4">
                    <legend class="w-auto pr-2 text-inox-green fw-semibold rounded px-2" style={{ marginTop: "-15px", background: "white", border: '1px solid #CFCFCF' }}>FD Release</legend>
                    <div className="row">
                      <div className="col-3">
                        <div class="form-group mb-2">
                          <label for="fd_release_approved_by" class="col-12 col-form-label font-12px">FD Release Approved By</label>
                          <div class="col-12">
                            <select id="fd_release_approved_by" name="fd_release_approved_by" className="form-select form-select-sm" onChange={(e) => setFdReleaseApprovedBy(e.target.value)}>
                              <option value="" selected={fdReleaseApprovedBy == "" ? true : false}>Select User</option>
                              {userList.map(user => (
                                <option value={user?.id} selected={user.id == fdReleaseApprovedBy ? true : false}>{user?.name}</option>
                              ))}
                            </select>
                          </div>
                        </div>
                      </div>

                      <div className="col-3">
                        <div class="form-group mb-2">
                          <label for="fd_release_date" class="col-12 col-form-label font-12px">FD Release Date</label>
                          <div class="col-12">
                            <input type="date" id="fd_release_date" name="fd_release_date" className="form-control form-control-sm" min={1} value={fdReleaseDate} 
                            onChange={(e) => setFdReleaseDate(e.target.value)}/>
                          </div>
                        </div>
                      </div>
                    </div>
                  </fieldset>

                  <fieldset class="border px-3 pb-3 rounded bg-light mt-4">
                    <legend class="w-auto pr-2 text-inox-green fw-semibold rounded px-2" style={{ marginTop: "-15px", background: "white", border: '1px solid #CFCFCF' }}>Track</legend>
                    <div className="row">
                      <div className="col-3">
                        <div class="form-group mb-2">
                          <label for="in_transit_to" class="col-12 col-form-label font-12px">In Transit To</label>
                          <div class="col-12">
                            <select id="in_transit_to" name="in_transit_to" className="form-select form-select-sm" onChange={(e) => setInTransitTo(e.target.value)}>
                              <option value="" selected={inTransitTo == "" ? true : false}>Select Port</option>
                              {portList.map(port => (
                                <option value={port?.id} selected={port.id == inTransitTo?.id ? true : false}>{port?.name}</option>
                              ))}
                            </select>
                          </div>
                        </div>
                      </div>

                      <div className="col-3">
                        <div class="form-group mb-2">
                          <label for="in_transit_to" class="col-12 col-form-label font-12px">Export Status</label>
                          <div class="col-12">
                            <select id="in_transit_to" name="in_transit_to" className="form-select form-select-sm" onChange={(e) => setExportStatus(e.target.value)}>
                              <option value="OPEN" selected={exportStatus == "OPEN" ? true : false}>OPEN</option>
                              <option value="CLOSE" selected={exportStatus == "CLOSE" ? true : false}>CLOSE</option>
                            </select>
                          </div>
                        </div>
                      </div>

                      <div className="col-3">
                        <div class="form-group mb-2">
                          <label for="depot" class="col-12 col-form-label font-12px">Depot</label>
                          <div class="col-12">
                            <select id="depot" name="depot" className="form-select form-select-sm" onChange={(e) => setCurrentDepot(e.target.value)}>
                              <option value="" selected={currentDepot == "" ? true : false}>Select Depot</option>
                              {depotList.map(depot => (
                                <option value={depot?.id} selected={currentDepot?.id == depot.id? true : false}>{depot?.name}</option>
                              ))}
                            </select>
                          </div>
                        </div>
                      </div>
                    </div>
                  </fieldset>

                  <fieldset class="border px-3 pb-3 rounded bg-light mt-4">
                    <legend class="w-auto pr-2 text-inox-green fw-semibold rounded px-2" style={{ marginTop: "-15px", background: "white", border: '1px solid #CFCFCF' }}>Remarks</legend>
                    <div className="row">
                      <div className="col-12">
                        <div class="form-group mb-2">
                          <label for="in_transit_to" class="col-12 col-form-label font-12px">Remarks</label>
                          <div class="col-12">
                            <input type="text" id="remarks" name="remarks" className="form-control form-control-sm" value={remarks}></input>
                          </div>
                        </div>
                      </div>
                    </div>
                  </fieldset>
                </form>

                <div className="row">
                  <div className="col-6">
                    <fieldset class="border px-3 pb-3 rounded bg-light mt-4">
                      <legend class="w-auto pr-2 text-inox-green fw-semibold rounded px-2" style={{ marginTop: "-15px", background: "white", border: '1px solid #CFCFCF' }}>Class And UN No</legend>
                      <div className="row">
                        <div className="col-12">
                          <DataTable
                            columns={shipmenthazardousclasscolumns}
                            data={shipmentHazardousClassInformationData}
                            progressPending={shipmentHazardousClassInformationDataPending}
                            progressComponent={<Spinner className="mx-5 text-inox-green table-spinner" as="span" animation="border" size="lg" role="status" aria-hidden="true" />}
                            noDataComponent={<p className="text-center my-5">No Class Data Found</p>}
                            highlightOnHover
                            fixedHeader
                            customStyles={hazardousDataTableCustomStyles}
                            dense
                          />
                        </div>
                      </div>
                    </fieldset>
                  </div>

                  <div className="col-6">
                    <fieldset class="border px-3 pb-3 rounded bg-light mt-4">
                      <legend class="w-auto pr-2 text-inox-green fw-semibold rounded px-2" style={{ marginTop: "-15px", background: "white", border: '1px solid #CFCFCF' }}>Booking Party KYC</legend>
                      <div className="row">
                        <div className="col-12">
                          <DataTable
                            columns={shipmentdocumentcolumns}
                            data={shipmentDocumentData}
                            progressPending={shipmentDocumentDataPending}
                            progressComponent={<Spinner className="mx-5 text-inox-green table-spinner" as="span" animation="border" size="lg" role="status" aria-hidden="true" />}
                            noDataComponent={<p className="text-center my-5">No Documents Found</p>}
                            highlightOnHover
                            fixedHeader
                            customStyles={shipmentUploadsTableCustomStyles}
                            dense
                          />
                        </div>
                      </div>
                    </fieldset>
                  </div>

                  <div className="col-6">
                    <fieldset class="border px-3 pb-3 rounded bg-light mt-4">
                      <legend class="w-auto pr-2 text-inox-green fw-semibold rounded px-2" style={{ marginTop: "-15px", background: "white", border: '1px solid #CFCFCF' }}>Route and Vessel Planning</legend>
                      <div className="row">
                        <div className="col-12">
                          <div class="float-right">
                            <button class="btn btn-inox-green btn-sm text-white" onClick={() => handleShowAddVesselRouteModal()}>Add Route</button>
                          </div>
                        </div>
                        <div className="col-12">
                          <DataTable
                            columns={transhipmentlegcolumns}
                            data={vesselTranshipmentLeg}
                            progressPending={vesselTranshipmentLegPending}
                            progressComponent={<Spinner className="mx-5 text-inox-green table-spinner" as="span" animation="border" size="lg" role="status" aria-hidden="true" />}
                            noDataComponent={<p className="text-center my-5">No Vessel Route Found</p>}
                            highlightOnHover
                            fixedHeader
                            customStyles={userTableCustomStyles}
                            dense
                          />
                        </div>
                      </div>
                    </fieldset>

                    <Modal dialogClassName="custom-modal" style={{ background: 'rgba(0, 0, 0, 0.5)' }} show={showAddVesselRouteModal} onHide={() => handleCloseAddVesselRouteModal()} centered>
                      <Modal.Header closeButton>
                        <Modal.Title>Add Vessel Route (Leg: {routeLeg})</Modal.Title>
                      </Modal.Header>
                      <Modal.Body>
                        <div className="row">
                          <div className="col-12">
                            <form ref={addrouteform}>
                              <div className="row">
                                <div className="col-4">
                                  <div class="form-group mb-2">
                                    <label for="pick_port" class="col-12 col-form-label font-12px">Pick Port</label>
                                    <div class="col-12">
                                      <Select
                                        options={selectablePortList}
                                        id="pick_port"
                                        name="pick_port"
                                        onChange={(e) => setAgreementPickPort(e)}
                                        isMulti={false}
                                        isClearable
                                        className="px-0"
                                        placeholder="Select Pick Port"
                                        styles={smallFormSelectCustomStyles}
                                        value={agreementPickPort}
                                      />
                                    </div>
                                  </div>
                                </div>

                                <div className="col-4">
                                  <div class="form-group mb-2">
                                    <label for="next_port" class="col-12 col-form-label font-12px">Next Port</label>
                                    <div class="col-12">
                                      <Select
                                        options={selectablePortList}
                                        id="next_port"
                                        name="next_port"
                                        onChange={(e) => setAgreementNextPort(e)}
                                        isMulti={false}
                                        isClearable
                                        className="px-0"
                                        placeholder="Select Next Port"
                                        styles={smallFormSelectCustomStyles}
                                        value={agreementNextPort}
                                      />
                                    </div>
                                  </div>
                                </div>

                                <div className="col-4">
                                  <div class="form-group mb-2">
                                    <label for="mode_of_transport" class="col-12 col-form-label font-12px">Mode of Transport</label>
                                    <div class="col-12">
                                      <select className="form-select form-select-sm" id="mode_of_transport" name="mode_of_transport" onChange={(e) => setModeOfTransport(e.target.value)}>
                                        <option value="" selected={modeOfTransport==""?true:false}>Select Mode</option>
                                        <option value="SHIP" selected={modeOfTransport=="SHIP"?true:false}>SHIP</option>
                                        <option value="TRAIN" selected={modeOfTransport=="TRAIN"?true:false}>TRAIN</option>
                                        <option value="TRUCK" selected={modeOfTransport=="TRUCK"?true:false}>TRUCK</option>
                                      </select>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div className="row">
                                <div className="col-4">
                                  <div class="form-group mb-2">
                                    <label for="tsp_agent" class="col-12 col-form-label font-12px">TSP Agent</label>
                                    <div class="col-12">
                                      <select className="form-select form-select-sm" id="tsp_agent" name="tsp_agent" onChange={(e) => setTranshipmentAgent(e.target.value)}>
                                        <option value="" selected="">Select Agent</option>
                                        {agentList.map(agent => (
                                          <option value={agent.id}>{agent.name}</option>
                                        ))}
                                      </select>
                                    </div>
                                  </div>
                                </div>

                                <div className="col-4">
                                  <div class="form-group mb-2">
                                    <label for="slot_operator" class="col-12 col-form-label font-12px">Slot Operator</label>
                                    <div class="col-12">
                                      <select className="form-select form-select-sm" id="slot_operator" name="slot_operator" onChange={(e) => setAgreementSlotOperator(e.target.value)}>
                                        <option value="" selected="">Select Agent</option>
                                        {operatorList.map(operator => (
                                          <option value={operator.id}>{operator.name}</option>
                                        ))}
                                      </select>
                                    </div>
                                  </div>
                                </div>

                                <div className="col-4">
                                  <div class="form-group mb-2">
                                    <label for="slot_payment_agent" class="col-12 col-form-label font-12px">Slot Payment Agent</label>
                                    <div class="col-12">
                                      <select className="form-select form-select-sm" id="slot_payment_agent" name="slot_payment_agent" onChange={(e) => setAgreementPaymentAgent(e.target.value)}>
                                        <option value="" selected="">Select Agent</option>
                                        {agentList.map(agent => (
                                          <option value={agent.id}>{agent.name}</option>
                                        ))}
                                      </select>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div className="row">
                                <div className="col-12 text-center mt-4">
                                  <Button className="btn btn-inox-green btn-sm px-4 border-0" onClick={(e) => searchVesselRoute(agreementPickPort?.value, agreementNextPort?.value, modeOfTransport)}
                                    disabled={agreementPickPort && agreementNextPort && modeOfTransport && agreementSlotOperator && agreementPaymentAgent?false:true}>
                                    {searchVesselRouteLoader?
                                      <Spinner className="mx-3 text-white" as="span" animation="border" size="sm" role="status" aria-hidden="true" />
                                    :
                                      "Search Route"
                                    }
                                  </Button>
                                </div>
                              </div>
                            </form>
                          </div>

                          <hr className="my-3"></hr>

                          <div className="col-8">
                            <h4>Available Vessels</h4>
                            <DataTable
                              columns={schedule_columns}
                              data={vesselScheduleList}
                              progressPending={vesselRoutePending}
                              progressComponent={<Spinner className="mx-5 text-inox-green" style={{ marginTop: 100, marginBottom: 100 }} as="span" animation="border" size="lg" role="status" aria-hidden="true" />}
                              noDataComponent={<p className="text-center" style={{ marginTop: 100, marginBottom: 100 }}>No Vessel Schedule Found</p>}
                              pagination
                              highlightOnHover
                              fixedHeader
                              customStyles={vesselScheduleTableCustomStyles}
                              dense
                            />
                          </div>

                          <div className="col-4">
                            <h4>Slot Agreements</h4>
                            <DataTable
                              columns={slot_rate_columns}
                              data={slotRateList}
                              progressComponent={<Spinner className="mx-5 text-inox-green table-spinner" as="span" animation="border" size="lg" role="status" aria-hidden="true" />}
                              noDataComponent={<p className="text-center" style={{ marginTop: 100, marginBottom: 100 }}>No Agreements Found</p>}
                              pagination
                              highlightOnHover
                              fixedHeader
                              customStyles={vesselScheduleTableCustomStyles}
                              dense
                            />
                          </div>

                          <div className="col-12 text-center">
                             <button class="btn btn-inox-green btn-sm text-white px-3" onClick={() => handleShowAddFreightModal()}>Confirm Vessel</button>
                          </div>
                        </div>
                      </Modal.Body>
                    </Modal>
                  </div>

                  <div className="col-6">
                    <fieldset class="border px-3 pb-3 rounded bg-light mt-4">
                      <legend class="w-auto pr-2 text-inox-green fw-semibold rounded px-2" style={{ marginTop: "-15px", background: "white", border: '1px solid #CFCFCF' }}>Freight Agreements</legend>
                      <div className="row">
                        <div className="col-12">
                          <div class="float-right">
                            <button class="btn btn-inox-green btn-sm text-white" onClick={() => handleShowAddFreightModal()}>Add Freight</button>
                          </div>
                        </div>
                        <div className="col-12">
                          <DataTable
                            columns={shipmentfreightcolumns}
                            data={freightChargeData}
                            progressPending={vesselTranshipmentLegPending}
                            progressComponent={<Spinner className="mx-5 text-inox-green table-spinner" as="span" animation="border" size="lg" role="status" aria-hidden="true" />}
                            noDataComponent={<p className="text-center my-5">No Freight Charges Found</p>}
                            highlightOnHover
                            fixedHeader
                            customStyles={userTableCustomStyles}
                            dense
                          />
                        </div>
                      </div>
                    </fieldset>

                    <Modal size="md" style={{ background: 'rgba(0, 0, 0, 0.5)' }} show={showAddFreightModal} onHide={() => handleCloseAddFreightModal()} centered>
                      <Modal.Header closeButton>
                        <Modal.Title>Add Freight</Modal.Title>
                      </Modal.Header>
                      <Modal.Body>
                        <form ref={addfreightform}>
                          <div className="row">
                            <div className="col-12">
                              <div class="form-group mb-2">
                                <label for="poa" class="col-12 col-form-label font-12px">Type</label>
                                <div class="col-12">
                                  <select className="form-select form-select-sm" id="freight_type" name="freight_type">
                                    <option value="" selected="">Select Container</option>
                                    {containerList.map(container => (
                                      <option value={container.id}>{container.product_name}</option>
                                    ))}
                                  </select>
                                </div>
                              </div>
                            </div>

                            <div className="col-12">
                              <div class="form-group mb-2">
                                <label for="poa" class="col-12 col-form-label font-12px">Quantity</label>
                                <div class="col-12">
                                  <input type="number" id="freight_quantity" name="freight_quantity" min={1} className="form-control form-control-sm"></input>
                                </div>
                              </div>
                            </div>

                            <div className="col-12">
                              <div class="form-group mb-2">
                                <label for="poa" class="col-12 col-form-label font-12px">Charge</label>
                                <div class="col-12">
                                  <input type="number" id="freight_charge" name="freight_charge" min={0} className="form-control form-control-sm"></input>
                                </div>
                              </div>
                            </div>

                            <div className="col-12 text-center mt-4">
                              <Button className="btn btn-inox-green btn-sm px-4 border-0" onClick={(e) => addFreightCharge(e)}>
                                {addFreightChargeLoader?
                                  <Spinner className="mx-3 text-white" as="span" animation="border" size="sm" role="status" aria-hidden="true" />
                                :
                                  "Add"
                                }
                              </Button>
                            </div>
                          </div>
                        </form>
                      </Modal.Body>
                    </Modal>


                    <Modal size="md" style={{ background: 'rgba(0, 0, 0, 0.5)' }} show={showUpdateFreightModal} onHide={() => setShowUpdateFreightModal(false)} centered>
                      <Modal.Header closeButton>
                        <Modal.Title>Update Freight</Modal.Title>
                      </Modal.Header>
                      <Modal.Body>
                        <form>
                          <div className="row">
                            <div className="col-12">
                              <div class="form-group mb-2">
                                <label for="poa" class="col-12 col-form-label font-12px">Type</label>
                                <div class="col-12">
                                  <select className="form-select form-select-sm" id="freight_type" name="freight_type" onChange={(e) => setUpdateFreightType(e.target.value)}>
                                    <option value="" selected="">Select Container</option>
                                    {containerList.map(container => (
                                      <option value={container.id} selected={updateFreightType==container.id?true:false}>{container.product_name}</option>
                                    ))}
                                  </select>
                                </div>
                              </div>
                            </div>

                            <div className="col-12">
                              <div class="form-group mb-2">
                                <label for="poa" class="col-12 col-form-label font-12px">Quantity</label>
                                <div class="col-12">
                                  <input type="number" id="freight_quantity" name="freight_quantity" min={1} className="form-control form-control-sm"
                                  value={updateFreightQuantity} onChange={(e) => setUpdateFreightQuantity(e.target.value)}></input>
                                </div>
                              </div>
                            </div>

                            <div className="col-12">
                              <div class="form-group mb-2">
                                <label for="poa" class="col-12 col-form-label font-12px">Charge</label>
                                <div class="col-12">
                                  <input type="number" id="freight_charge" name="freight_charge" min={0} className="form-control form-control-sm"
                                  value={updateFreightChargeAmount} onChange={(e) => setUpdateFreightChargeAmount(e.target.value)}></input>
                                </div>
                              </div>
                            </div>

                            <div className="col-12 text-center mt-4">
                              <Button className="btn btn-inox-green btn-sm px-4 border-0" onClick={(e) => updateFreightCharge(e)}>
                                {updateFreightChargeLoader?
                                  <Spinner className="mx-3 text-white" as="span" animation="border" size="sm" role="status" aria-hidden="true" />
                                :
                                  "Update"
                                }
                              </Button>
                            </div>
                          </div>
                        </form>
                      </Modal.Body>
                    </Modal>

                    <Modal size="md" style={{ background: 'rgba(0, 0, 0, 0.5)' }} show={showDeleteFreightModal} onHide={() => setShowDeleteFreightModal(false)} centered>
                      <Modal.Header closeButton>
                        <Modal.Title>Delete Freight</Modal.Title>
                      </Modal.Header>
                      <Modal.Body>
                        <form>
                          <div className="row">
                            <div className="col-12">
                              Do you want to delete this freight charge?
                            </div>

                            <div className="col-12 text-center mt-4">
                              <Button className="btn btn-secondary btn-sm px-4 border-0 mx-1" onClick={(e) => setShowDeleteFreightModal(false)}>Cancel</Button>

                              <Button className="btn btn-inox-green btn-sm px-4 border-0" onClick={(e) => deleteFreightCharge(e)}>
                                {deleteFreightChargeLoader?
                                  <Spinner className="mx-3 text-white" as="span" animation="border" size="sm" role="status" aria-hidden="true" />
                                :
                                  "Delete"
                                }
                              </Button>

                              
                            </div>
                          </div>
                        </form>
                      </Modal.Body>
                    </Modal>
                  </div>
                </div>
              </div>

              <div style={{ display: activeTab == "Notes" ? "block" : "none" }} className="mt-3">
                <div className="col-12">
                  <div class="float-left">
                    <select className="form-select" onClick={(e) => getShipmentNotes(e.target.value)}>
                      <option value="">ALL</option>
                      <option value="PRIVATE">PRIVATE</option>
                      <option value="PUBLIC">PUBLIC</option>
                    </select>
                  </div>
                  <div class="float-right">
                    <button class="btn btn-inox-green btn-sm text-white" onClick={() => handleShowAddShipmentNotesModal()}>Add Notes</button>
                  </div>
                </div>
                <DataTable
                  columns={shipmentnotescolumns}
                  data={shipmentNotesData}
                  progressPending={shipmentNotesDataPending}
                  progressComponent={<Spinner className="mx-5 text-inox-green table-spinner" as="span" animation="border" size="lg" role="status" aria-hidden="true" />}
                  noDataComponent={<p className="text-center my-5">No Shipment Notes Found</p>}
                  highlightOnHover
                  fixedHeader
                  customStyles={userTableCustomStyles}
                  dense
                />

                <Modal size="md" style={{ background: 'rgba(0, 0, 0, 0.5)' }} show={showAddShipmentNotesModal} onHide={() => handleCloseAddShipmentNotesModal()} centered>
                  <Modal.Header closeButton>
                    <Modal.Title>Add Notes</Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    <form ref={addshipmentnotesform}>
                      <div className="row">
                        <div className="col-12">
                          <div class="form-group mb-2">
                            <label for="notes_type" class="col-12 col-form-label font-12px">Type</label>
                            <div class="col-12">
                              <select className="form-select form-select-sm" id="shipment_notes_type" name="shipment_notes_type">
                                <option value="" selected="">Select Type</option>
                                <option value="PRIVATE">PRIVATE</option>
                                <option value="PUBLIC">PUBLIC</option>
                              </select>
                            </div>
                          </div>
                        </div>

                        <div className="col-12">
                          <div class="form-group mb-2">
                            <label for="notes" class="col-12 col-form-label font-12px">Notes</label>
                            <div class="col-12">
                              <textarea id="shipment_notes" name="shipment_notes" rows="5" className="form-control form-control-sm"></textarea>
                            </div>
                          </div>
                        </div>

                        <div className="col-12 text-center mt-4">
                          <Button className="btn btn-inox-green btn-sm px-4 border-0" onClick={(e) => addShipmentNotes(e)}>
                            {addShipmentNotesLoader?
                              <Spinner className="mx-3 text-white" as="span" animation="border" size="sm" role="status" aria-hidden="true" />
                            :
                              "Add"
                            }
                          </Button>
                        </div>
                      </div>
                    </form>
                  </Modal.Body>
                </Modal>


                <Modal size="md" style={{ background: 'rgba(0, 0, 0, 0.5)' }} show={showUpdateShipmentNotesModal} onHide={() => setShowUpdateShipmentNotesModal(false)} centered>
                  <Modal.Header closeButton>
                    <Modal.Title>Update Notes</Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    <form>
                      <div className="row">
                        <div className="col-12">
                          <div class="form-group mb-2">
                            <label for="notes_type" class="col-12 col-form-label font-12px">Type</label>
                            <div class="col-12">
                              <select className="form-select form-select-sm" id="notes_type" name="notes_type" onChange={(e) => setUpdateShipmentNotesType(e.target.value)}>
                                <option value="" selected="">Select Type</option>
                                <option value="PRIVATE" selected={updateShipmentNotesType=="PRIVATE"?true:false}>PRIVATE</option>
                                <option value="PUBLIC" selected={updateShipmentNotesType=="PUBLIC"?true:false}>PUBLIC</option>
                              </select>
                            </div>
                          </div>
                        </div>

                        <div className="col-12">
                          <div class="form-group mb-2">
                            <label for="notes" class="col-12 col-form-label font-12px">Notes</label>
                            <div class="col-12">
                              <textarea id="notes" name="notes" rows="5" className="form-control form-control-sm" onChange={(e) => setUpdateShipmentNote(e.target.value)} value={updateShipmentNote}></textarea>
                            </div>
                          </div>
                        </div>

                        <div className="col-12 text-center mt-4">
                          <Button className="btn btn-inox-green btn-sm px-4 border-0" onClick={(e) => updateShipmentNotes(e)}>
                            {updateShipmentNotesLoader?
                              <Spinner className="mx-3 text-white" as="span" animation="border" size="sm" role="status" aria-hidden="true" />
                            :
                              "Update"
                            }
                          </Button>
                        </div>
                      </div>
                    </form>
                  </Modal.Body>
                </Modal>

                <Modal size="md" style={{ background: 'rgba(0, 0, 0, 0.5)' }} show={showDeleteShipmentNotesModal} onHide={() => setShowDeleteShipmentNotesModal(false)} centered>
                  <Modal.Header closeButton>
                    <Modal.Title>Delete Notes</Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    <form>
                      <div className="row">
                        <div className="col-12">
                          Do you want to delete this freight charge?
                        </div>

                        <div className="col-12 text-center mt-4">
                          <Button className="btn btn-secondary btn-sm px-4 border-0 mx-1" onClick={(e) => setShowDeleteShipmentNotesModal(false)}>Cancel</Button>

                          <Button className="btn btn-inox-green btn-sm px-4 border-0" onClick={(e) => deleteShipmentNotes(e)}>
                            {deleteShipmentNotesLoader?
                              <Spinner className="mx-3 text-white" as="span" animation="border" size="sm" role="status" aria-hidden="true" />
                            :
                              "Delete"
                            }
                          </Button>
                        </div>
                      </div>
                    </form>
                  </Modal.Body>
                </Modal>
              </div>

              <div style={{ display: activeTab == "CRO" ? "block" : "none" }} className="mt-3">
                <PlannedExportCro 
                  shipmentId={shipmentId}
                  agentList={agentList}
                  principalList={principalList}
                  userList={userList}
                  portList={portList}
                  terminalList={terminalList}
                  containerList={containerList}
                  selectableContainerList={selectableContainerList}
                  depotList={depotList}
                  vesselList={vesselList}
                  operatorList={operatorList}
                  cargoList={cargoList}
                  currentUserRolePermissionData={currentUserRolePermissionData}
                  loggedInUser={loggedInUser}
                >
                </PlannedExportCro>
              </div>

              <div style={{ display: activeTab == "ExportBilling" ? "block" : "none" }} className="mt-3">
                <PlannedExportExportBilling 
                  shipmentId={shipmentId}
                  agentList={agentList}
                  principalList={principalList}
                  userList={userList}
                  portList={portList}
                  terminalList={terminalList}
                  containerList={containerList}
                  selectableContainerList={selectableContainerList}
                  depotList={depotList}
                  vesselList={vesselList}
                  customerList={customerList}
                  operatorList={operatorList}
                  cargoList={cargoList}
                  currentUserRolePermissionData={currentUserRolePermissionData}
                  loggedInUser={loggedInUser}
                >
                </PlannedExportExportBilling>
              </div>

              <div style={{ display: activeTab == "BL" ? "block" : "none" }} className="mt-3">
                <PlannedExportBl 
                  shipmentId={shipmentId}
                  agentList={agentList}
                  principalList={principalList}
                  userList={userList}
                  portList={portList}
                  terminalList={terminalList}
                  containerList={containerList}
                  selectableContainerList={selectableContainerList}
                  depotList={depotList}
                  vesselList={vesselList}
                  customerList={customerList}
                  operatorList={operatorList}
                  cargoList={cargoList}
                  currentUserRolePermissionData={currentUserRolePermissionData}
                  loggedInUser={loggedInUser}
                >
                </PlannedExportBl>
              </div>

              <div style={{ display: activeTab == "Containers" ? "block" : "none" }} className="mt-3">
                <PlannedExportContainer 
                  shipmentId={shipmentId}
                  agentList={agentList}
                  principalList={principalList}
                  userList={userList}
                  portList={portList}
                  terminalList={terminalList}
                  containerList={containerList}
                  selectableContainerList={selectableContainerList}
                  depotList={depotList}
                  vesselList={vesselList}
                  customerList={customerList}
                  operatorList={operatorList}
                  cargoList={cargoList}
                  currentUserRolePermissionData={currentUserRolePermissionData}
                  loggedInUser={loggedInUser}
                >
                </PlannedExportContainer>
              </div>

              <div style={{ display: activeTab == "Activities" ? "block" : "none" }} className="mt-3">
                <PlannedExportActivities 
                  shipmentId={shipmentId}
                  agentList={agentList}
                  principalList={principalList}
                  userList={userList}
                  portList={portList}
                  terminalList={terminalList}
                  containerList={containerList}
                  selectableContainerList={selectableContainerList}
                  depotList={depotList}
                  vesselList={vesselList}
                  customerList={customerList}
                  operatorList={operatorList}
                  cargoList={cargoList}
                  currentUserRolePermissionData={currentUserRolePermissionData}
                  loggedInUser={loggedInUser}
                >
                </PlannedExportActivities>
              </div>

              <div style={{ display: activeTab == "Notifications" ? "block" : "none" }} className="mt-3">
                <PlannedExportNotifications 
                  shipmentId={shipmentId}
                  agentList={agentList}
                  principalList={principalList}
                  userList={userList}
                  portList={portList}
                  terminalList={terminalList}
                  containerList={containerList}
                  selectableContainerList={selectableContainerList}
                  depotList={depotList}
                  vesselList={vesselList}
                  customerList={customerList}
                  operatorList={operatorList}
                  cargoList={cargoList}
                  currentUserRolePermissionData={currentUserRolePermissionData}
                  loggedInUser={loggedInUser}
                >
                </PlannedExportNotifications>
              </div>

              <div style={{ display: activeTab == "Tasks" ? "block" : "none" }} className="mt-3">
                <PlannedExportTasks 
                  shipmentId={shipmentId}
                  agentList={agentList}
                  principalList={principalList}
                  userList={userList}
                  portList={portList}
                  terminalList={terminalList}
                  containerList={containerList}
                  selectableContainerList={selectableContainerList}
                  depotList={depotList}
                  vesselList={vesselList}
                  customerList={customerList}
                  operatorList={operatorList}
                  cargoList={cargoList}
                  currentUserRolePermissionData={currentUserRolePermissionData}
                  loggedInUser={loggedInUser}
                >
                </PlannedExportTasks>
              </div>

              <div style={{ display: activeTab == "Expenses" ? "block" : "none" }} className="mt-3">
                <PlannedExportExpenses 
                  shipmentId={shipmentId}
                  agentList={agentList}
                  principalList={principalList}
                  userList={userList}
                  portList={portList}
                  terminalList={terminalList}
                  containerList={containerList}
                  selectableContainerList={selectableContainerList}
                  depotList={depotList}
                  vesselList={vesselList}
                  customerList={customerList}
                  operatorList={operatorList}
                  cargoList={cargoList}
                  currentUserRolePermissionData={currentUserRolePermissionData}
                  loggedInUser={loggedInUser}
                >
                </PlannedExportExpenses>
              </div>

              <div style={{ display: activeTab == "Documents" ? "block" : "none" }} className="mt-3">
                <PlannedExportDocuments 
                  shipmentId={shipmentId}
                  agentList={agentList}
                  principalList={principalList}
                  userList={userList}
                  portList={portList}
                  terminalList={terminalList}
                  containerList={containerList}
                  selectableContainerList={selectableContainerList}
                  depotList={depotList}
                  vesselList={vesselList}
                  customerList={customerList}
                  operatorList={operatorList}
                  cargoList={cargoList}
                  currentUserRolePermissionData={currentUserRolePermissionData}
                  loggedInUser={loggedInUser}
                >
                </PlannedExportDocuments>
              </div>

              <div style={{ display: activeTab == "Uploads" ? "block" : "none" }} className="mt-3">
                <PlannedExportUploads 
                  shipmentId={shipmentId}
                  agentList={agentList}
                  principalList={principalList}
                  userList={userList}
                  portList={portList}
                  terminalList={terminalList}
                  containerList={containerList}
                  selectableContainerList={selectableContainerList}
                  depotList={depotList}
                  vesselList={vesselList}
                  customerList={customerList}
                  operatorList={operatorList}
                  cargoList={cargoList}
                  currentUserRolePermissionData={currentUserRolePermissionData}
                  loggedInUser={loggedInUser}
                >
                </PlannedExportUploads>
              </div>

              <div style={{ display: activeTab == "Chat" ? "block" : "none" }} className="mt-3">
                <PlannedExportChat 
                  shipmentId={shipmentId}
                  agentList={agentList}
                  principalList={principalList}
                  userList={userList}
                  portList={portList}
                  terminalList={terminalList}
                  containerList={containerList}
                  selectableContainerList={selectableContainerList}
                  depotList={depotList}
                  vesselList={vesselList}
                  customerList={customerList}
                  operatorList={operatorList}
                  cargoList={cargoList}
                  currentUserRolePermissionData={currentUserRolePermissionData}
                  loggedInUser={loggedInUser}
                >
                </PlannedExportChat>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      {/*  --------------------------- Miscellaneous Charges ---------------------------- */}
      <Modal size="xl" style={{ background: 'rgba(0, 0, 0, 0.5)' }} show={showMiscellaneousChargesModal} onHide={() => setShowMiscellaneousChargesModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Miscellaneous Charges</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {miscellaneousChargeRows.map((row, index) => (
            <div class={`row tarrif-add-charge-form ${index != 0 ? 'mt-2' : ''}`}>
              <div class="col-2">
                <Select
                  options={miscellaneousChargeList}
                  id={"miscellaneous_charge" + index}
                  name={"miscellaneous_charge" + index}
                  onChange={(e) => [handleMiscellaneousChargeChange(index, row.id, "charge_name", e), setMiscellaneousChargeRows([...miscellaneousChargeRows])]}
                  isMulti={false}
                  isClearable
                  className="px-0"
                  placeholder="Charge Name"
                  value={miscellaneousChargeRows[index]['charge_data']}
                />
              </div>

              <div class="col-3">
                <textarea rows={2} className="form-control form-control-sm w-100" value={miscellaneousChargeRows[index]['remarks']} disabled></textarea>
              </div>

              <div class="col-1">
                <input
                  type="number"
                  id={"miscellaneous_charge_amount" + index}
                  name={"miscellaneous_charge_amount" + index}
                  className="form-control"
                  placeholder={miscellaneousChargeRows[index]['amount'] ? miscellaneousChargeRows[index]['amount'] : "Amount"}
                  onChange={(e) => [handleMiscellaneousChargeChange(index, row.id, "amount", e.target.value), setMiscellaneousChargeRows([...miscellaneousChargeRows])]}
                />
              </div>

              <div class="col-1">
                <input
                  type="number"
                  id={"miscellaneous_charge_quantity" + index}
                  name={"miscellaneous_charge_quantity" + index}
                  className="form-control"
                  placeholder={miscellaneousChargeRows[index]['quantity'] ? miscellaneousChargeRows[index]['quantity'] : "Quantity"}
                  onChange={(e) => [handleMiscellaneousChargeChange(index, row.id, "quantity", e.target.value), setMiscellaneousChargeRows([...miscellaneousChargeRows])]}
                />
              </div>

              {/* <div class="col-1">
                <input
                  type="number"
                  id={"miscellaneous_charge_requested" + index}
                  name={"miscellaneous_charge_requested" + index}
                  className="form-control"
                  placeholder={miscellaneousChargeRows[index]['requested'] ? miscellaneousChargeRows[index]['requested'] : "Requested"}
                  onChange={(e) => handleMiscellaneousChargeChange(index, row.id, "requested", e.target.value)}
                  disabled
                  hidden
                />
              </div>

              <div class="col-1">
                <input
                  type="number"
                  id={"miscellaneous_charge_approved" + index}
                  name={"miscellaneous_charge_approved" + index}
                  className="form-control"
                  placeholder={miscellaneousChargeRows[index]['approved'] ? miscellaneousChargeRows[index]['approved'] : "Approved"}
                  onChange={(e) => handleMiscellaneousChargeChange(index, row.id, "approved", e.target.value)}
                  disabled
                  hidden
                />
              </div> */}

              <div class="col-2">
                <Select
                  options={currencyList}
                  id={"miscellaneous_charge_currency" + index}
                  name={"miscellaneous_charge_currency" + index}
                  onChange={(e) => [handleMiscellaneousChargeChange(index, row.id, "currency", e), setMiscellaneousChargeRows([...miscellaneousChargeRows])]}
                  isMulti={false}
                  isClearable
                  className="px-0"
                  placeholder="Currency"
                  value={miscellaneousChargeRows[index]['currency_data']}
                />
              </div>

              <div class="col-2">
                <select
                  id={"miscellaneous_charge_paid_by" + index}
                  name={"miscellaneous_charge_paid_by" + index}
                  className="form-select text-muted"
                  onChange={(e) => [handleMiscellaneousChargeChange(index, row.id, "paid_by", e.target.value), setMiscellaneousChargeRows([...miscellaneousChargeRows])]}>
                  <option value="" selected={miscellaneousChargeRows[index]['paid_by']==""?true:false} disabled>Paid By</option>
                  <option value="NA" selected={miscellaneousChargeRows[index]['paid_by']=="NA"?true:false}>NA</option>
                  <option value="SHIPPER" selected={miscellaneousChargeRows[index]['paid_by']=="SHIPPER"?true:false}>Shipper</option>
                  <option value="CONSIGNEE" selected={miscellaneousChargeRows[index]['paid_by']=="CONSIGNEE"?true:false}>Consignee</option>
                </select>
              </div>

              <div class="col-1 px-0">
                <Button
                  className="btn btn-danger mx-1"
                  title="Remove Cargo"
                  onClick={() => removeMiscellaneousChargeRow(row, index)}
                >
                  <i className="fa fa-trash"></i>
                </Button>

                <Button
                  className="btn btn-inox-green border-0"
                  title="Add Charge"
                  onClick={() => addMiscellaneousChargeRow()}
                >
                  <i className="fa fa-plus"></i>
                </Button>
              </div>
            </div>
          ))}

          <div className="row mt-5">
            <div className="col-12 text-center">
              <Button className="btn btn-sm btn-secondary mx-2" style={{ width: 150 }} onClick={() => [setShowMiscellaneousChargesModal(false), setMiscellaneousChargeRows([{
                                                                                                                                                                              id: generateId,
                                                                                                                                                                              product_data: { "product_name": "Miscellaneous" },
                                                                                                                                                                              product_name: "Miscellaneous",
                                                                                                                                                                              charge_data: "",
                                                                                                                                                                              charge_name: "",
                                                                                                                                                                              remarks: "",
                                                                                                                                                                              amount: 0.0,
                                                                                                                                                                              expense: 0.0,
                                                                                                                                                                              amount_type: "AMOUNT",
                                                                                                                                                                              charge_basis: "",
                                                                                                                                                                              currency_data: null,
                                                                                                                                                                              currency: "",
                                                                                                                                                                              quantity: 1,
                                                                                                                                                                              total: 0.0,
                                                                                                                                                                              requested: 0.0,
                                                                                                                                                                              approved: 0.0,
                                                                                                                                                                              paid_by: "",
                                                                                                                                                                              approved_by: ""
                                                                                                                                                                            }])]}>Cancel</Button>
              <Button className="btn btn-sm btn-inox-green border-0" style={{ width: 150 }} onClick={() => [setShowMiscellaneousChargesModal(false), console.log(miscellaneousChargeRows)]}>Save</Button>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      <Modal size="md" style={{ background: 'rgba(0, 0, 0, 0.5)' }} show={showBringToDraftModal} onHide={() => setShowBringToDraftModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title><i className="fa fa-notes text-info"></i> Bring to Draft</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>Are you sure you want to bring this shipment back to draft?</p>
          <div className="row mt-5">
            <div className="col-12 text-center">
              <Button className="btn btn-sm btn-secondary mx-2" style={{ width: 150 }} onClick={() => setShowBringToDraftModal(false)}>No</Button>
              <Button className="btn btn-sm btn-inox-green border-0" style={{ width: 150 }} onClick={(e) => bringtodraft(e)}>
                {showBringToDraftLoader?
                  <Spinner className="mx-2 text-white" as="span" animation="border" size="sm" role="status" aria-hidden="true" />
                :
                  "Yes"
                }
              </Button>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      <Modal size="md" style={{ background: 'rgba(0, 0, 0, 0.5)' }} show={showCancelBookingModal} onHide={() => setShowCancelBookingModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title><i className="fa fa-times text-danger"></i> Cancel Booking</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>Are you sure you want to cancel this booking?</p>
          <div className="row mt-5">
            <div className="col-12 text-center">
              <Button className="btn btn-sm btn-secondary mx-2" style={{ width: 150 }} onClick={() => setShowCancelBookingModal(false)}>No</Button>
              <Button className="btn btn-sm btn-inox-green border-0" style={{ width: 150 }} onClick={(e) => cancelbooking(e)}>
                {showCancelBookingLoader?
                  <Spinner className="mx-2 text-white" as="span" animation="border" size="sm" role="status" aria-hidden="true" />
                :
                  "Yes"
                }
              </Button>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      <Modal size="md" style={{ background: 'rgba(0, 0, 0, 0.5)' }} show={showReleaseAtFdModal} onHide={() => setShowReleaseAtFdModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title><i className="fa fa-check text-success"></i> Release at FD</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>Are you sure you want to release containers at FD?</p>
          <div className="row mt-5">
            <div className="col-12 text-center">
              <Button className="btn btn-sm btn-secondary mx-2" style={{ width: 150 }} onClick={() => setShowReleaseAtFdModal(false)}>No</Button>
              <Button className="btn btn-sm btn-inox-green border-0" style={{ width: 150 }} onClick={(e) => releaseatfd(e)}>
                {showReleaseAtFdLoader?
                  <Spinner className="mx-2 text-white" as="span" animation="border" size="sm" role="status" aria-hidden="true" />
                :
                  "Yes"
                }
              </Button>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      <Modal size="md" style={{ background: 'rgba(0, 0, 0, 0.5)' }} show={showCloseExportModal} onHide={() => setShowCloseExportModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title><i className="fa fa-ban text-secondary"></i> Close Export</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>Are you sure you want to close export for this booking?</p>
          <div className="row mt-5">
            <div className="col-12 text-center">
              <Button className="btn btn-sm btn-secondary mx-2" style={{ width: 150 }} onClick={() => setShowCloseExportModal(false)}>No</Button>
              <Button className="btn btn-sm btn-inox-green border-0" style={{ width: 150 }} onClick={(e) => closeexport(e)}>
                {showCloseExportLoader?
                  <Spinner className="mx-2 text-white" as="span" animation="border" size="sm" role="status" aria-hidden="true" />
                :
                  "Yes"
                }
              </Button>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      <Modal size="xl" show={showSplitBookingModal} onHide={() => setShowSplitBookingModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Booking Number: {bookingForSplit?.reference_number}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div class="form-group row">
            <label class="col-sm-3 col-form-label">Split booking into:</label>
            <div class="col-sm-9">
              <input 
                type="number" 
                className="form form-control" 
                style={{ width: 100 }} 
                max={bookingForSplit?.shipment_container}
                value={maxSplit}
                onChange={(e) => {
                  if(e.target.value > bookingForSplit?.shipment_container){
                    setBookingSplitCount(bookingForSplit?.shipment_container)
                    setMaxSplit(bookingForSplit?.shipment_container);
                    generateBookingSplitRows(bookingForSplit?.shipment_container)
                    toast.warning("Booking cannot be split beyond the available container count.")
                  }
                  else{
                    setMaxSplit(e.target.value);
                    setBookingSplitCount(e.target.value)
                    generateBookingSplitRows(e.target.value)
                  }
                }}>
              </input>
            </div>
          </div>

          <div className="row">
            <div className="col-3">
              <label class="col-form-label mt-2">Divide Containers: </label>
            </div>

            <div className="col-9 mt-2">
              <div>
                {Array.from({ length: bookingSplitCount }).map((_, index) => (
                  <div key={index}>
                    <div className="row mb-1">
                      <div className="col-2">
                        <input 
                          type="text" 
                          className="form form-control" 
                          style={{ width: 100 }} 
                          onChange={(e) => handleContainerSplit(index, e.target.value, bookingSplitRows?.[index]?.container)}
                          value={bookingSplitRows?.[index]?.container_quantity ?? 0}/>
                      </div>

                      <div className="col-3 mt-2">
                        <small>Containers in Booking {index + 1}</small>
                      </div>

                      <div className="col-7 mt-2">
                        <Select
                          options={bookingPickedContainerList}
                          isOptionDisabled={(option) =>
                            bookingSplitRows
                              .map(row => row.picked_container?.value)
                              .includes(option.value)
                          }
                          onChange={(e) => handleContainerSplit(index, bookingSplitRows?.[index]?.container_quantity, e)}
                          isMulti={bookingSplitRows?.[index]?.container_quantity > 1? true:false}
                          isClearable
                          className="px-0"
                          placeholder="Select Container"
                          styles={smallFormSelectCustomStyles}
                        />
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button className="btn btn-sm btn-secondary mx-2" style={{ width: 100 }} onClick={() => {
                                                                                                    setShowSplitBookingModal(false)
                                                                                                    setBookingSplitCount(1)
                                                                                                    setMaxSplit(1)
                                                                                                    setBookingSplitRows([{ index: 0, container_quantity: 1 }])
                                                                                                  }}>Close</Button>
          <Button 
            className="btn btn-sm btn-success mx-2" 
            style={{ width: 100 }} 
            disabled={bookingPickedContainerList.length > 0?false:true}
            onClick={() => split_booking()}>
            {splitBookingLoader?
              <Spinner className="mx-3 text-white" as="span" animation="border" size="sm" role="status" aria-hidden="true" />
            :
              "Split"
            }
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default PlannedExport;
